// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | (string & {});
};

/**
 * Serializer for BallotEntitlement responses.
 */
export type BallotEntitlement = {
    readonly id: string;
    proxy_intermediary_ballot_id: string;
    investor_account_id: string;
    readonly ballot_breakdown_metadata_id: string | null;
    ballot_proportion: number;
    investor_supported_issued_instrument_id?: string | null;
    investor_policy_supported_issued_instrument_id?: string | null;
    fund_manager_policy_supported_issued_instrument_id?: string | null;
    readonly create_time: Date;
    readonly update_time: Date;
    invalid_time?: Date | null;
};

/**
 * Serializer for ballot voting information.
 */
export type BallotInvestorsCanVote = {
    /**
     * Number of investor accounts expected to vote on this ballot
     */
    num_investor_accounts_expected_to_vote: number;
    /**
     * List of investor accounts expected to vote with their fund proportions
     */
    investor_accounts: Array<InvestorAccountVoteInfo>;
    /**
     * Whether this ballot requires investigation due to potentially missing or inaccurate entitlements
     */
    requires_investigation: boolean;
    /**
     * Reason why investigation is required (empty if not required)
     */
    requires_investigation_reason: string;
};

export type BatchVoterWithHoldingsInputRequest = {
    /**
     * List of voters with their holdings
     */
    voters: Array<VoterWithHoldingsInputRequest>;
};

export type BatchVoterWithHoldingsResponse = {
    /**
     * Newly created voters
     */
    created: Array<VoterResponse>;
    /**
     * Updated voters
     */
    updated: Array<VoterResponse>;
};

/**
 * Response serializer for ballot breakdown computation result.
 */
export type BreakdownResponse = {
    /**
     * Breakdown metadata including ballot ID, security ISIN, and filters
     */
    metadata: {
        [key: string]: unknown;
    };
    /**
     * Statistics about the breakdown (node counts, edge counts, etc.)
     */
    statistics: {
        [key: string]: unknown;
    };
    /**
     * NetworkX graph in node-link JSON format
     */
    graph: {
        [key: string]: unknown;
    };
};

/**
 * Individual component difference in a composition
 */
export type ComponentDiff = {
    /**
     * Name of the organization
     */
    organization_name?: string | null;
    /**
     * ISIN identifier for the holding
     */
    isin: string;
    /**
     * Holding's Classification of Financial Instruments (CFI) code
     */
    cfi?: string | null;
    /**
     * Status of the component (UNCHANGED, ADDED, or REMOVED)
     *
     * * `UNCHANGED` - UNCHANGED
     * * `ADDED` - ADDED
     * * `REMOVED` - REMOVED
     * * `FILTERED` - FILTERED
     */
    status: StatusEnum;
    /**
     * Reasons why the component was filtered
     */
    filter_reasons: Array<FilterReasonsEnum>;
    /**
     * Name of the voting policy in format 'votingPolicies/{uuid}'
     */
    voting_policy_name?: string | null;
    /**
     * Start date of this component diff
     */
    start_date: Date;
};

/**
 * Individual component difference in a composition
 */
export type ComponentDiffRequest = {
    /**
     * Name of the organization
     */
    organization_name?: string | null;
    /**
     * ISIN identifier for the holding
     */
    isin: string;
    /**
     * Holding's Classification of Financial Instruments (CFI) code
     */
    cfi?: string | null;
    /**
     * Status of the component (UNCHANGED, ADDED, or REMOVED)
     *
     * * `UNCHANGED` - UNCHANGED
     * * `ADDED` - ADDED
     * * `REMOVED` - REMOVED
     * * `FILTERED` - FILTERED
     */
    status: StatusEnum;
    /**
     * Reasons why the component was filtered
     */
    filter_reasons: Array<FilterReasonsEnum>;
    /**
     * Name of the voting policy in format 'votingPolicies/{uuid}'
     */
    voting_policy_name?: string | null;
    /**
     * Start date of this component diff
     */
    start_date: Date;
};

/**
 * Response serializer for composition differences
 */
export type CompositionDifferenceResponse = {
    /**
     * Name of the investor who holds this diff
     */
    investor_name: string;
    /**
     * List of component differences
     */
    components: Array<ComponentDiff>;
};

/**
 * Request serializer for computing ballot breakdown.
 */
export type ComputeBreakdownRequestRequest = {
    /**
     * ID of the proxy intermediary ballot
     */
    proxy_intermediary_ballot_id: string;
    /**
     * Start of the validity window (ISO 8601 format). If not provided, defaults to VAT - 1 day
     */
    valid_from?: Date | null;
    /**
     * End of the validity window (ISO 8601 format). If not provided, defaults to VAT
     */
    valid_to?: Date | null;
    /**
     * Type of investor: 'institutional', 'retail', or 'all' for all investor types
     *
     * * `institutional` - institutional
     * * `retail` - retail
     * * `all` - all
     */
    investor_type: InvestorTypeEnum;
};

/**
 * * `TUMELO` - TUMELO
 * * `PIRC` - PIRC
 * * `GLASS_LEWIS` - GLASS_LEWIS
 * * `MINERVA` - MINERVA
 * * `ISS` - ISS
 * * `EOS` - EOS
 * * `ISS_RETAIL` - ISS_RETAIL
 */
export const DiffFormatEnum = {
    TUMELO: 'TUMELO',
    PIRC: 'PIRC',
    GLASS_LEWIS: 'GLASS_LEWIS',
    MINERVA: 'MINERVA',
    ISS: 'ISS',
    EOS: 'EOS',
    ISS_RETAIL: 'ISS_RETAIL'
} as const;

/**
 * * `TUMELO` - TUMELO
 * * `PIRC` - PIRC
 * * `GLASS_LEWIS` - GLASS_LEWIS
 * * `MINERVA` - MINERVA
 * * `ISS` - ISS
 * * `EOS` - EOS
 * * `ISS_RETAIL` - ISS_RETAIL
 */
export type DiffFormatEnum = typeof DiffFormatEnum[keyof typeof DiffFormatEnum];

/**
 * Serializer for export result response.
 */
export type ExportResult = {
    /**
     * S3 bucket name where the exported CSV file is stored
     */
    s3_bucket: string;
    /**
     * S3 key (path) of the exported CSV file
     */
    s3_key: string;
    /**
     * Number of rows exported (0 if unavailable)
     */
    row_count: number;
    /**
     * Timestamp when export was executed
     */
    exported_at: Date;
};

export type FetchMinimalInstrumentsRequestRequest = {
    isins: Array<string>;
};

export type FetchMinimalInstrumentsResponse = {
    instruments: Array<MinimalInstrument>;
};

/**
 * * `NEW_PORTFOLIO_INVESTMENT` - NEW_PORTFOLIO_INVESTMENT
 * * `NOT_HELD_IN_PORTFOLIO` - NOT_HELD_IN_PORTFOLIO
 * * `POA_MARKET` - POA_MARKET
 * * `NON_SPLIT_VOTING_COUNTRY` - NON_SPLIT_VOTING_COUNTRY
 * * `OUT_OF_SCOPE_ISIN` - OUT_OF_SCOPE_ISIN
 * * `UNSUPPORTED_CFI_CODE` - UNSUPPORTED_CFI_CODE
 */
export const FilterReasonsEnum = {
    NEW_PORTFOLIO_INVESTMENT: 'NEW_PORTFOLIO_INVESTMENT',
    NOT_HELD_IN_PORTFOLIO: 'NOT_HELD_IN_PORTFOLIO',
    POA_MARKET: 'POA_MARKET',
    NON_SPLIT_VOTING_COUNTRY: 'NON_SPLIT_VOTING_COUNTRY',
    OUT_OF_SCOPE_ISIN: 'OUT_OF_SCOPE_ISIN',
    UNSUPPORTED_CFI_CODE: 'UNSUPPORTED_CFI_CODE'
} as const;

/**
 * * `NEW_PORTFOLIO_INVESTMENT` - NEW_PORTFOLIO_INVESTMENT
 * * `NOT_HELD_IN_PORTFOLIO` - NOT_HELD_IN_PORTFOLIO
 * * `POA_MARKET` - POA_MARKET
 * * `NON_SPLIT_VOTING_COUNTRY` - NON_SPLIT_VOTING_COUNTRY
 * * `OUT_OF_SCOPE_ISIN` - OUT_OF_SCOPE_ISIN
 * * `UNSUPPORTED_CFI_CODE` - UNSUPPORTED_CFI_CODE
 */
export type FilterReasonsEnum = typeof FilterReasonsEnum[keyof typeof FilterReasonsEnum];

export type FundManager = {
    readonly name: string;
    id: string;
    title: string;
    product: string;
    website_url: string | null;
    logo_url: string | null;
    logo_thumbnail_url: string | null;
    relationship_owner: string | null;
    create_time: Date;
    update_time: Date;
};

export type FundManagerPolicySii = {
    readonly name: string;
    fund_manager_name: string;
    voting_policy_name: string;
    public_security_id_name: string;
    create_time: Date;
    delete_time?: Date | null;
    valid_from: Date;
    valid_to?: Date | null;
};

export type FundManagerPolicySiiBatchCreateRequest = {
    fund_manager_name: string;
    voting_policy_name: string;
    instruments: Array<FundManagerPolicySiiInputRequest>;
};

export type FundManagerPolicySiiBatchDeleteRequest = {
    names: Array<string>;
};

/**
 * An instrument with an associated validity period, used as input for batch create operations.
 */
export type FundManagerPolicySiiInputRequest = {
    public_security_id_name: string;
    valid_from: Date;
    valid_to?: Date | null;
};

export type FundManagerPolicySiiResponse = {
    items: Array<FundManagerPolicySii>;
};

export type FundManagerSupportedIssuedInstrumentsQueryRequest = {
    /**
     * List of component differences
     */
    components: Array<ComponentDiffRequest>;
    /**
     * Date at which the supported instruments take effect
     */
    recomposition_date: Date;
    /**
     * Fund manager resource name in format 'fundManagers/<uuid>'
     */
    fund_manager_name: string;
    /**
     * List of voting policy names in format 'votingPolicies/<uuid>'
     */
    voting_policy_names: Array<string>;
};

/**
 * Serializer for FundManagerSupportedVotingPolicy responses.
 */
export type FundManagerSupportedVotingPolicy = {
    readonly id: string;
    readonly fund_manager_id: string;
    readonly voting_policy_id: string;
    readonly create_time: Date;
    readonly update_time: Date;
};

/**
 * Request serializer for batch upserting fund manager supported policies.
 */
export type FundManagerSupportedVotingPolicyBatchUpsertRequest = {
    /**
     * List of fund manager / voting policy links to upsert
     */
    policies: Array<FundManagerSupportedVotingPolicyItemRequest>;
};

/**
 * Response serializer for batch upserting fund manager supported policies.
 */
export type FundManagerSupportedVotingPolicyBatchUpsertResponse = {
    policies: Array<FundManagerSupportedVotingPolicy>;
};

/**
 * Serializer for historical FundManagerSupportedVotingPolicy records.
 */
export type FundManagerSupportedVotingPolicyHistorical = {
    id: string;
    fund_manager_id: string;
    voting_policy_id: string;
    create_time: Date;
    update_time: Date;
    /**
     * Present on as_of queries: the datetime this historical record was captured
     */
    history_date?: Date;
};

/**
 * Serializer for a single fund manager / voting policy link.
 */
export type FundManagerSupportedVotingPolicyItemRequest = {
    /**
     * UUID of the FundManager
     */
    fund_manager_id: string;
    /**
     * UUID of the VotingPolicy
     */
    voting_policy_id: string;
};

export type FundManagerWriteRequest = {
    title: string;
    product: string;
    website_url?: string | null;
    logo_url?: string | null;
    logo_thumbnail_url?: string | null;
    relationship_owner?: string | null;
};

export type Holding = {
    /**
     * Unique identifier for the holdings record
     */
    readonly id: string;
    /**
     * ISIN (International Securities Identification Number). Must be 12-character alphanumeric code.
     */
    isin?: string | null;
    /**
     * Number of shares held
     */
    settled_quantity: number;
    /**
     * CUSIP (Committee on Uniform Securities Identification Procedures) number. A 9-character alphanumeric code that identifies North American financial securities.
     */
    cusip: string;
    /**
     * When the holdings record is valid
     */
    valid_time: Date;
    /**
     * When the holdings record was created
     */
    readonly create_time: Date;
    /**
     * When the holdings record was last updated
     */
    readonly update_time: Date;
    /**
     * Reference to the voter owning the holdings
     */
    voter_id: string;
};

/**
 * Serializer for creating holdings (without voter_id).
 */
export type HoldingInputRequest = {
    /**
     * ISIN (International Securities Identification Number). Must be 12-character alphanumeric code.
     */
    isin?: string | null;
    /**
     * Number of shares held
     */
    settled_quantity: number;
    /**
     * CUSIP (Committee on Uniform Securities Identification Procedures) number. A 9-character alphanumeric code that identifies North American financial securities.
     */
    cusip: string;
    /**
     * When the holdings record is valid
     */
    valid_time: Date;
};

export type HoldingResponse = {
    /**
     * List of holdings for the voter
     */
    holdings: Array<Holding>;
};

export type Instrument = {
    readonly name: string;
    isin: string;
    title: string;
    mifir_identifier_code: string;
    is_composite: boolean;
    cfi: string | null;
    readonly public_security_id_names: Array<string>;
};

export type InstrumentWriteRequest = {
    isin?: string;
    title: string;
    mifir_identifier_code: string;
    is_composite: boolean;
    cfi?: string | null;
    public_security_id_names?: Array<string>;
};

/**
 * Serializer for individual investor account voting information.
 */
export type InvestorAccountVoteInfo = {
    /**
     * Unique identifier of the habitat for the investor account
     */
    habitat_id: string;
    /**
     * Unique identifier of the investor account
     */
    investor_account_id: string;
    /**
     * Unique identifier of the investor
     */
    investor_id: string;
    /**
     * External identifier of the investor (displayable)
     */
    investor_external_id: string;
    /**
     * Investor type: 'institutional', 'retail_ptv', or 'unknown'
     */
    investor_type: string;
    /**
     * Combined fund proportion from the ballot breakdown graph. Null for accounts not in breakdown.
     */
    ballot_combined_fund_proportion?: number | null;
    /**
     * Whether this investor has manual votes. Null when no meeting entitlement data is available.
     */
    has_manual_votes?: boolean | null;
    /**
     * Whether this investor account is expected to vote based on the breakdown, and their SIIs. False for accounts not in the breakdown (they have validated entitlements we didn't expect).
     */
    expected_to_vote: boolean;
    /**
     * Number of validated meeting entitlements expected for this investor account on this ballot. For accounts not in the breakdown but with validated entitlements, defaults to the count of their validated entitlement IDs (they have entitlements we didn't expect based on the breakdown).
     */
    expected_validated_meeting_entitlements: number;
    /**
     * Combined fund proportion from validated meeting entitlement (None when no validated entitlement)
     */
    meeting_entitlement_combined_fund_proportion?: number | null;
    /**
     * List of validated meeting entitlement IDs associated with this investor account for this ballot
     */
    validated_meeting_entitlement_ids: Array<string>;
};

export type InvestorPolicySii = {
    readonly name: string;
    voting_policy_name: string;
    public_security_id_name: string;
    create_time: Date;
    delete_time?: Date | null;
    valid_from: Date;
    valid_to?: Date | null;
};

export type InvestorPolicySiiBatchCreateRequest = {
    investor_name: string;
    voting_policy_name: string;
    instruments: Array<InvestorPolicySiiInputRequest>;
};

export type InvestorPolicySiiBatchDeleteRequest = {
    names: Array<string>;
};

/**
 * An instrument with an associated validity period, used as input for batch create operations.
 */
export type InvestorPolicySiiInputRequest = {
    public_security_id_name: string;
    valid_from: Date;
    valid_to?: Date | null;
};

export type InvestorPolicySiiResponse = {
    items: Array<InvestorPolicySii>;
};

export type InvestorRulesEngine = {
    readonly id: number;
    investor_name: string;
    rules_engine_name?: string | null;
    readonly created_at: Date;
    readonly updated_at: Date;
};

export type InvestorRulesEngineRequest = {
    investor_name: string;
    rules_engine_name?: string | null;
};

export type InvestorSiiBatchCreateRequest = {
    investor_name: string;
    instruments: Array<InvestorSiiInputRequest>;
};

export type InvestorSiiBatchDeleteRequest = {
    names: Array<string>;
};

/**
 * An instrument with an associated validity period, used as input for batch create operations.
 */
export type InvestorSiiInputRequest = {
    public_security_id_name: string;
    valid_from: Date;
    valid_to?: Date | null;
};

export type InvestorSiiResponse = {
    items: Array<InvestorSupportedIssuedInstrument>;
};

export type InvestorSupportedIssuedInstrument = {
    readonly name: string;
    public_security_id_name: string;
    create_time: Date;
    delete_time?: Date | null;
    valid_from: Date;
    valid_to?: Date | null;
};

/**
 * * `institutional` - institutional
 * * `retail` - retail
 * * `all` - all
 */
export const InvestorTypeEnum = {
    INSTITUTIONAL: 'institutional',
    RETAIL: 'retail',
    ALL: 'all'
} as const;

/**
 * * `institutional` - institutional
 * * `retail` - retail
 * * `all` - all
 */
export type InvestorTypeEnum = typeof InvestorTypeEnum[keyof typeof InvestorTypeEnum];

/**
 * Request serializer for getting which investor accounts can vote on given ballots.
 */
export type InvestorsCanVoteRequest = {
    /**
     * List of proxy intermediary ballot IDs to check
     */
    proxy_intermediary_ballot_ids: Array<string>;
    /**
     * When True, sources meeting entitlements using an indirect lookup path instead of the direct PI ballot source ID. The indirect path uses: (1) custodian_account_fund_id from the ballot to find fund variant security IDs that map to owning_fund_security_id on meeting entitlements, (2) target_security_id to match issued_instrument_security_id, and (3) the PI ballot's linked general meeting via transparency_general_meeting_name. This approach avoids issues where multiple PI ballots exist for a single meeting entitlement.
     */
    source_meeting_entitlements_indirectly?: boolean;
};

/**
 * Response serializer containing voting information for all requested ballots.
 */
export type InvestorsCanVoteResponse = {
    /**
     * Dictionary mapping proxy intermediary ballot ID to investors can vote, and requires investigation information
     */
    ballots: {
        [key: string]: BallotInvestorsCanVote;
    };
};

export type Meeting = {
    /**
     * Unique identifier for the general meeting
     */
    general_meeting_id: string;
    /**
     * Resource name for the general meeting in the format
     * 'organizations/{organization_id}/generalMeetings/{general_meeting_id}'
     */
    readonly general_meeting_name: string;
    /**
     * Resource name for the organization in the format 'organizations/{organization_id}'
     */
    readonly organization_name: string;
    /**
     * Resource name for the meeting ballot in the format
     * 'habitats/{habitat_id}/meetingBallots/{meeting_ballot_id}'
     */
    readonly meeting_ballot_name: string;
    /**
     * Resource name for the scheme in the format 'habitats/{habitat_id}/schemes/{scheme_id}'
     */
    readonly scheme_name: string;
    /**
     * Date and time when the meeting is scheduled
     */
    meeting_date: Date;
    /**
     * Identifier for the habitat this meeting belongs to
     */
    habitat_id: string;
    /**
     * Unique identifier for the organization holding the meeting
     */
    organization_id: string;
    /**
     * Display name of the organization
     */
    organization_display_title: string;
    /**
     * URL to the organization's logo image
     */
    organization_logo_url?: string | null;
    /**
     * NAICS industry classification title for the organization
     */
    organization_naics_title: string;
    /**
     * Identifier for the meeting ballot
     */
    meeting_ballot_id: string;
    /**
     * Deadline for voting/taking action on meeting proposals
     */
    action_deadline: Date;
    /**
     * Identifier for the investment scheme
     */
    scheme_id: string;
    /**
     * List of theme/classification codes for proposals in this meeting (e.g., CC, OE, PR)
     */
    proposal_classification_codes?: Array<string>;
};

export type MeetingBallot = {
    /**
     * Unique identifier for the meeting ballot
     */
    readonly id: string;
    /**
     * The investor this ballot belongs to
     */
    investor: string;
    /**
     * The habitat this meeting ballot belongs to
     */
    habitat: string;
    /**
     * General meeting this ballot is associated with
     */
    general_meeting: string;
    /**
     * Earliest voting deadline across all PI ballots linked to this meeting ballot
     */
    earliest_voting_deadline: Date;
    /**
     * Latest voting deadline across all PI ballots linked to this meeting ballot
     */
    latest_voting_deadline: Date;
    readonly create_time: Date;
    readonly update_time: Date;
    complete_time?: Date | null;
};

export type MeetingBallotSource = {
    /**
     * Unique identifier for the meeting ballot source
     */
    readonly id: string;
    /**
     * The meeting ballot this source contributes to
     */
    meeting_ballot: string;
    /**
     * The PI ballot whose entitlements contributed to the meeting ballot
     */
    proxy_intermediary_ballot: string;
    /**
     * Investor SII context at the time the source was created
     */
    investor_supported_issued_instrument_id?: string | null;
    /**
     * Investor policy SII context at the time the source was created
     */
    investor_policy_supported_issued_instrument_id?: string | null;
    /**
     * Fund-manager policy SII context at the time the source was created
     */
    fund_manager_policy_supported_issued_instrument_id?: string | null;
    readonly create_time: Date;
    readonly update_time: Date;
    /**
     * When this source was soft-invalidated; NULL for active sources
     */
    invalid_time?: Date | null;
};

export type MinimalInstrument = {
    readonly name: string;
    isin: string;
    title: string;
    cfi: string | null;
};

export type PaginatedBallotEntitlementList = {
    next?: string | null;
    previous?: string | null;
    results: Array<BallotEntitlement>;
};

export type PaginatedFundManagerList = {
    next?: string | null;
    previous?: string | null;
    results: Array<FundManager>;
};

export type PaginatedFundManagerPolicySiiList = {
    next?: string | null;
    previous?: string | null;
    results: Array<FundManagerPolicySii>;
};

export type PaginatedFundManagerSupportedVotingPolicyHistoricalList = {
    next?: string | null;
    previous?: string | null;
    results: Array<FundManagerSupportedVotingPolicyHistorical>;
};

export type PaginatedInstrumentList = {
    next?: string | null;
    previous?: string | null;
    results: Array<Instrument>;
};

export type PaginatedInvestorPolicySiiList = {
    next?: string | null;
    previous?: string | null;
    results: Array<InvestorPolicySii>;
};

export type PaginatedInvestorSupportedIssuedInstrumentList = {
    next?: string | null;
    previous?: string | null;
    results: Array<InvestorSupportedIssuedInstrument>;
};

export type PaginatedMeetingBallotList = {
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingBallot>;
};

export type PaginatedMeetingBallotSourceList = {
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingBallotSource>;
};

export type PaginatedMeetingList = {
    next?: string | null;
    previous?: string | null;
    results: Array<Meeting>;
};

export type PaginatedPiBallotSearchList = {
    next?: string | null;
    previous?: string | null;
    results: Array<PiBallotSearch>;
};

export type PaginatedPiMeetingSearchList = {
    next?: string | null;
    previous?: string | null;
    results: Array<PiMeetingSearch>;
};

export type PaginatedPublicSecurityIdList = {
    next?: string | null;
    previous?: string | null;
    results: Array<PublicSecurityId>;
};

export type PaginatedRulesEngineDefinitionList = {
    next?: string | null;
    previous?: string | null;
    results: Array<RulesEngineDefinition>;
};

export type PaginatedRulesEngineRuleList = {
    next?: string | null;
    previous?: string | null;
    results: Array<RulesEngineRule>;
};

export type PaginatedSplitVoteInstructionOverwriteReasonList = {
    next?: string | null;
    previous?: string | null;
    results: Array<SplitVoteInstructionOverwriteReason>;
};

/**
 * Serializer for PI ballot search results.
 */
export type PiBallotSearch = {
    /**
     * Unique identifier for this specific version of the ballot
     */
    ballot_version_id: string;
    /**
     * Resource name for the proxy intermediary ballot in the format used by the workflow system.
     */
    readonly proxy_intermediary_ballot_name: string;
    /**
     * Resource name for the proxy intermediary meeting in the format used by the workflow system.
     */
    readonly proxy_intermediary_meeting_name: string;
    /**
     * Total number of shares available for voting on this ballot
     */
    available_shares: number;
    /**
     * Unique identity identifier for the ballot across all versions
     */
    ballot_identity_id: string;
    /**
     * External system identifier for the ballot (e.g., from proxy intermediary platform)
     */
    ballot_external_id: string;
    /**
     * Indicates if this is the most recent active version of the ballot
     */
    ballot_version_is_current: boolean;
    /**
     * Total number of ballots associated with the same proxy intermediary meeting
     */
    ballots_per_meeting: number;
    /**
     * Internal identifier for the custodian account holding the shares
     */
    custodian_account_id: string;
    /**
     * Account number assigned by the custodian institution
     */
    custodian_account_number: string;
    /**
     * Descriptive name or title of the custodian account
     */
    custodian_account_title: string;
    /**
     * Indicates if the ballot aligns with the fund manager's voting policy
     */
    fund_manager_policy_supported: boolean;
    /**
     * Name of the fund manager organization that manages the fund
     */
    fund_manager_title?: string | null;
    /**
     * UUID of the fund manager record
     */
    fund_manager_id?: string | null;
    /**
     * Name of the investment fund that owns the shares being voted
     */
    fund_title: string;
    /**
     * Official name of the shareholder meeting (e.g., Annual General Meeting 2024)
     */
    general_meeting_name: string;
    /**
     * Indicates if the ballot aligns with investor voting guidelines
     */
    investor_supported: boolean;
    /**
     * Indicates if the ballot is supported by formal investor policy recommendations
     */
    investor_policy_supported: boolean;
    /**
     * Name of the company or organization holding the shareholder meeting
     */
    organization_title: string;
    /**
     * CUSIP, ISIN, or other public identifier for the security being voted on
     */
    owned_public_security_id: string;
    /**
     * Display name of the proxy intermediary service provider
     */
    proxy_intermediary_title: string;
    /**
     * Meeting identifier where this ballot is being voted on
     */
    proxy_intermediary_meeting_id: string;
    /**
     * Identifier for the proxy intermediary managing this ballot
     */
    proxy_intermediary_id: string;
    /**
     * Indicates if additional validation is needed for split voting scenarios
     */
    split_vote_check_required: boolean;
    /**
     * Cutoff date and time for submitting votes on this ballot
     */
    vote_deadline: Date;
    /**
     * Current state in the voting workflow (e.g. pending, submitted, checked)
     */
    workflow_status: string;
    /**
     * Username of the person who submitted the vote for processing
     */
    workflow_submitter: string;
    /**
     * Username of the person who reviewed and approved the vote submission
     */
    workflow_checker: string;
    /**
     * UUID of the fund record, used to construct the fund resource name
     */
    fund_id?: string | null;
};

/**
 * Serializer for PI meeting search results.
 */
export type PiMeetingSearch = {
    /**
     * Unique identifier for this specific version of the meeting
     */
    meeting_version_id: string;
    /**
     * Resource name for the proxy intermediary meeting in the format used by the workflow system.
     */
    readonly proxy_intermediary_meeting_name: string;
    /**
     * Unique identity identifier for the meeting across all versions
     */
    meeting_identity_id: string;
    /**
     * Indicates if this is the most recent active version of the meeting
     */
    meeting_version_is_current: boolean;
    /**
     * Meeting identifier within the proxy intermediary system
     */
    proxy_intermediary_meeting_id: string;
    /**
     * Identifier for the proxy intermediary managing this meeting
     */
    proxy_intermediary_id: string;
    /**
     * External system identifier for the meeting (e.g., from proxy intermediary platform)
     */
    meeting_external_id: string;
    /**
     * Name of the company or organization holding the shareholder meeting
     */
    organization_title: string;
    /**
     * Official name of the shareholder meeting (e.g., Annual General Meeting 2024)
     */
    transparency_general_meeting_name: string;
    /**
     * Type of meeting (e.g., Annual General Meeting, Extraordinary General Meeting)
     */
    meeting_type: string;
    /**
     * Date and time when the meeting is scheduled to occur
     */
    meeting_time: Date;
    /**
     * Cutoff date and time for submitting votes for this meeting
     */
    submission_deadline: Date;
    /**
     * Record date for determining shareholder eligibility
     */
    record_date?: Date | null;
    /**
     * Indicates if the meeting contains contested proposals
     */
    is_contested: boolean;
    /**
     * Indicates if split voting is supported for this meeting
     */
    is_split_voting_supported?: boolean | null;
    /**
     * Additional comments or notes about the meeting
     */
    meeting_comment?: string | null;
    /**
     * Reason why the meeting might not be supported
     */
    unsupported_reason?: string | null;
    /**
     * Date and time when the meeting was cancelled, if applicable
     */
    cancel_time?: Date | null;
    /**
     * Array of security identifiers associated with this meeting
     */
    security_ids?: Array<string> | null;
    /**
     * Identifier for the voting operations workflow
     */
    workflow_id?: string | null;
    /**
     * Current state in the voting workflow (e.g. new, ready_for_refinement, successful)
     */
    workflow_status?: string | null;
    /**
     * Username of the person assigned to refine the meeting data
     */
    workflow_refiner?: string | null;
    /**
     * Username of the person assigned to check the meeting data
     */
    workflow_checker?: string | null;
    /**
     * Display name of the proxy intermediary service provider
     */
    proxy_intermediary_title?: string | null;
    /**
     * Indicates if any of the meeting's securities are supported by investor policies
     */
    investor_supported?: boolean;
    /**
     * Indicates if any of the meeting's securities are supported by investor policy guidelines
     */
    investor_policy_supported?: boolean;
    /**
     * Indicates if any of the meeting's securities are supported by fund manager policies
     */
    fund_manager_policy_supported?: boolean;
    /**
     * Number of ballots associated with this meeting
     */
    ballot_count: number;
    /**
     * Indicates if the meeting has associated ballots available for voting
     */
    has_ballots: boolean;
    /**
     * Date and time when the meeting was first created in the proxy intermediary system
     */
    meeting_create_time: Date;
    /**
     * Latest valid_to date across all SIIs for this meeting's securities, or NULL if any SII has no expiry
     */
    latest_valid_to_sii?: Date | null;
    /**
     * the earliest submission deadline for ballots on the meetingnull if no ballots with submission deadlines present
     */
    earliest_ballot_submission_deadline?: Date | null;
};

/**
 * Serializer for a policy.
 */
export type Policy = {
    /**
     * Unique identifier for the policy
     */
    readonly id: string;
    /**
     * Identifier to be shared externally with integrated parties
     */
    readonly external_id: string;
    /**
     * Title of the voting policy
     */
    title: string;
    /**
     * Title of the voting policy provider
     */
    provider_title: string;
    /**
     * Description of the voting policy in formatted text
     */
    formatted_description?: string | null;
    /**
     * Key referencing the document associated with the voting policy
     */
    document_key?: string | null;
    /**
     * Indicates if the selected policy is currently available on direct outreach
     */
    is_available?: boolean | null;
    /**
     * When the voting policy was created
     */
    readonly create_time: Date;
    /**
     * When the voting policy was last updated
     */
    readonly update_time: Date;
};

/**
 * Serializer for a policy.
 */
export type PolicyRequest = {
    /**
     * Title of the voting policy
     */
    title: string;
    /**
     * Title of the voting policy provider
     */
    provider_title: string;
    /**
     * Description of the voting policy in formatted text
     */
    formatted_description?: string | null;
    /**
     * Key referencing the document associated with the voting policy
     */
    document_key?: string | null;
    /**
     * Indicates if the selected policy is currently available on direct outreach
     */
    is_available?: boolean | null;
};

/**
 * Serializer for policy response.
 */
export type PolicyResponse = {
    /**
     * Unique identifier for the policy
     */
    readonly id: string;
    /**
     * Identifier to be shared externally with integrated parties
     */
    external_id: string;
    /**
     * Title of the voting policy
     */
    title: string;
    /**
     * Title of the voting policy provider
     */
    provider_title: string;
    /**
     * Description of the voting policy in formatted text
     */
    formatted_description?: string | null;
    /**
     * Key referencing the document associated with the voting policy
     */
    document_key?: string | null;
    /**
     * Indicates if the selected policy is currently available on direct outreach
     */
    is_available?: boolean | null;
    /**
     * When the voting policy was created
     */
    readonly create_time: Date;
    /**
     * When the voting policy was last updated
     */
    readonly update_time: Date;
};

export type PublicSecurityId = {
    readonly name: string;
    create_time: Date;
};

/**
 * Request serializer for rendering a composition difference in a specific format.
 */
export type RenderCompositionDifferenceRequest = {
    /**
     * Name of the investor
     */
    investor_name: string;
    /**
     * List of component differences to render
     */
    components: Array<ComponentDiffRequest>;
    /**
     * Output format for the rendered composition difference
     *
     * * `TUMELO` - TUMELO
     * * `PIRC` - PIRC
     * * `GLASS_LEWIS` - GLASS_LEWIS
     * * `MINERVA` - MINERVA
     * * `ISS` - ISS
     * * `EOS` - EOS
     * * `ISS_RETAIL` - ISS_RETAIL
     */
    diff_format: DiffFormatEnum;
};

/**
 * * `vote_adjusted_for_voting_restriction` - Vote Adjusted for Voting Restriction
 * * `vote_adjusted_for_contested_meeting` - Vote Adjusted for Contested Meeting
 * * `vote_aligned_with_fm_due_to_restriction` - Vote Aligned with FM Due to Restriction
 * * `vote_aligned_with_fm_due_to_proposal_restriction` - Vote Aligned with FM Due to Proposal Restriction
 */
export const ReportableReasonEnum = {
    VOTE_ADJUSTED_FOR_VOTING_RESTRICTION: 'vote_adjusted_for_voting_restriction',
    VOTE_ADJUSTED_FOR_CONTESTED_MEETING: 'vote_adjusted_for_contested_meeting',
    VOTE_ALIGNED_WITH_FM_DUE_TO_RESTRICTION: 'vote_aligned_with_fm_due_to_restriction',
    VOTE_ALIGNED_WITH_FM_DUE_TO_PROPOSAL_RESTRICTION: 'vote_aligned_with_fm_due_to_proposal_restriction'
} as const;

/**
 * * `vote_adjusted_for_voting_restriction` - Vote Adjusted for Voting Restriction
 * * `vote_adjusted_for_contested_meeting` - Vote Adjusted for Contested Meeting
 * * `vote_aligned_with_fm_due_to_restriction` - Vote Aligned with FM Due to Restriction
 * * `vote_aligned_with_fm_due_to_proposal_restriction` - Vote Aligned with FM Due to Proposal Restriction
 */
export type ReportableReasonEnum = typeof ReportableReasonEnum[keyof typeof ReportableReasonEnum];

/**
 * * `COUNTRY_SCOPE` - Country Scope
 * * `ISIN_SCOPE` - ISIN Scope
 * * `CFI_REGEX` - CFI Regex
 */
export const RuleTypeEnum = {
    COUNTRY_SCOPE: 'COUNTRY_SCOPE',
    ISIN_SCOPE: 'ISIN_SCOPE',
    CFI_REGEX: 'CFI_REGEX'
} as const;

/**
 * * `COUNTRY_SCOPE` - Country Scope
 * * `ISIN_SCOPE` - ISIN Scope
 * * `CFI_REGEX` - CFI Regex
 */
export type RuleTypeEnum = typeof RuleTypeEnum[keyof typeof RuleTypeEnum];

/**
 * Read serializer for RulesEngineDefinition.
 */
export type RulesEngineDefinition = {
    readonly id: string;
    name: string;
    valid_from: Date;
    readonly create_time: Date;
    readonly update_time: Date;
};

/**
 * Write serializer for creating a RulesEngineDefinition.
 */
export type RulesEngineDefinitionCreateRequest = {
    name: string;
    valid_from: Date;
};

/**
 * Response serializer for the list-by-name endpoint.
 */
export type RulesEngineNamesResponse = {
    names: Array<string>;
};

/**
 * Read serializer for RulesEngineRule.
 */
export type RulesEngineRule = {
    readonly id: string;
    readonly definition_id: string;
    rule_type: RuleTypeEnum;
    order: number;
    parameters: unknown;
    readonly create_time: Date;
    readonly update_time: Date;
};

/**
 * Write serializer for creating or updating a RulesEngineRule.
 */
export type RulesEngineRuleWriteRequest = {
    rule_type: RuleTypeEnum;
    order: number;
    parameters: unknown;
};

export type SelectedPolicy = {
    /**
     * Unique identifier for the selected policy record
     */
    readonly id: string;
    /**
     * The title of the voter's selected policy
     */
    readonly policy_title: string | null;
    /**
     * When the selected policy record was created
     */
    readonly create_time: Date;
    /**
     * Reference to the voter selecting the policy
     */
    voter_id: string;
    /**
     * Reference to the selected policy
     */
    policy_id: string;
};

/**
 * Serializer for creating/updating a selected policy.
 */
export type SelectedPolicyRequestRequest = {
    /**
     * The ID of the policy to select
     */
    policy_id: string;
};

/**
 * Serializer for the selected policy response wrapper.
 */
export type SelectedPolicyResponse = {
    /**
     * The voter's selected policy, or null if none selected
     */
    selectedPolicy: SelectedPolicy | null;
};

export type SplitVoteInstructionOverwriteReason = {
    /**
     * Reportable reason for the overwrite
     *
     * * `vote_adjusted_for_voting_restriction` - Vote Adjusted for Voting Restriction
     * * `vote_adjusted_for_contested_meeting` - Vote Adjusted for Contested Meeting
     * * `vote_aligned_with_fm_due_to_restriction` - Vote Aligned with FM Due to Restriction
     * * `vote_aligned_with_fm_due_to_proposal_restriction` - Vote Aligned with FM Due to Proposal Restriction
     */
    reportable_reason: ReportableReasonEnum;
    /**
     * Description of the overwrite reason for internal use
     */
    description: string;
};

export type SplitVoteInstructionProposalOverwrite = {
    /**
     * Unique identifier for the SVI Proposal Overwrite
     */
    readonly id: string;
    /**
     * Internal reason for the overwrite, not reportable
     */
    internal_reason?: string | null;
    /**
     * Author of the overwrite
     */
    author: string;
    /**
     * Investor votes FOR
     */
    investor_votes_for: number;
    /**
     * Investor votes AGAINST
     */
    investor_votes_against: number;
    /**
     * Investor votes ABSTAIN
     */
    investor_votes_abstain: number;
    /**
     * Investor votes WITHHOLD
     */
    investor_votes_withhold: number;
    /**
     * Investor votes NO VOTE
     */
    investor_votes_no_vote: number;
    /**
     * Investor votes ONE YEAR
     */
    investor_votes_one_year: number;
    /**
     * Investor votes TWO YEARS
     */
    investor_votes_two_years: number;
    /**
     * Investor votes THREE YEARS
     */
    investor_votes_three_years: number;
    /**
     * Split votes FOR
     */
    split_votes_for: number;
    /**
     * Split votes AGAINST
     */
    split_votes_against: number;
    /**
     * Split votes ABSTAIN
     */
    split_votes_abstain: number;
    /**
     * Split votes WITHHOLD
     */
    split_votes_withhold: number;
    /**
     * Split votes NO VOTE
     */
    split_votes_no_vote: number;
    /**
     * Split votes ONE YEAR
     */
    split_votes_one_year: number;
    /**
     * Split votes TWO YEARS
     */
    split_votes_two_years: number;
    /**
     * Split votes THREE YEARS
     */
    split_votes_three_years: number;
    /**
     * Percentage of split votes FOR
     */
    split_votes_percentage_for: number;
    /**
     * Percentage of split votes AGAINST
     */
    split_votes_percentage_against: number;
    /**
     * Percentage of split votes ABSTAIN
     */
    split_votes_percentage_abstain: number;
    /**
     * Percentage of split votes WITHHOLD
     */
    split_votes_percentage_withhold: number;
    /**
     * Percentage of split votes NO VOTE
     */
    split_votes_percentage_no_vote: number;
    /**
     * Percentage of split votes ONE YEAR
     */
    split_votes_percentage_one_year: number;
    /**
     * Percentage of split votes TWO YEARS
     */
    split_votes_percentage_two_years: number;
    /**
     * Percentage of split votes THREE YEARS
     */
    split_votes_percentage_three_years: number;
    /**
     * When the overwrite was created
     */
    readonly create_time: Date;
    /**
     * When the overwrite was deleted
     */
    readonly delete_time: Date | null;
    /**
     * Reference to the SVI Proposal being overwritten
     */
    split_vote_instruction_proposal_id: string;
    /**
     * Reportable reason for overwriting the SVI Proposal
     */
    reportable_reason: ReportableReasonEnum;
};

export type SplitVoteInstructionProposalOverwriteRequest = {
    /**
     * Internal reason for the overwrite, not reportable
     */
    internal_reason?: string | null;
    /**
     * Author of the overwrite
     */
    author: string;
    /**
     * Investor votes FOR
     */
    investor_votes_for: number;
    /**
     * Investor votes AGAINST
     */
    investor_votes_against: number;
    /**
     * Investor votes ABSTAIN
     */
    investor_votes_abstain: number;
    /**
     * Investor votes WITHHOLD
     */
    investor_votes_withhold: number;
    /**
     * Investor votes NO VOTE
     */
    investor_votes_no_vote: number;
    /**
     * Investor votes ONE YEAR
     */
    investor_votes_one_year: number;
    /**
     * Investor votes TWO YEARS
     */
    investor_votes_two_years: number;
    /**
     * Investor votes THREE YEARS
     */
    investor_votes_three_years: number;
    /**
     * Split votes FOR
     */
    split_votes_for: number;
    /**
     * Split votes AGAINST
     */
    split_votes_against: number;
    /**
     * Split votes ABSTAIN
     */
    split_votes_abstain: number;
    /**
     * Split votes WITHHOLD
     */
    split_votes_withhold: number;
    /**
     * Split votes NO VOTE
     */
    split_votes_no_vote: number;
    /**
     * Split votes ONE YEAR
     */
    split_votes_one_year: number;
    /**
     * Split votes TWO YEARS
     */
    split_votes_two_years: number;
    /**
     * Split votes THREE YEARS
     */
    split_votes_three_years: number;
    /**
     * Percentage of split votes FOR
     */
    split_votes_percentage_for: number;
    /**
     * Percentage of split votes AGAINST
     */
    split_votes_percentage_against: number;
    /**
     * Percentage of split votes ABSTAIN
     */
    split_votes_percentage_abstain: number;
    /**
     * Percentage of split votes WITHHOLD
     */
    split_votes_percentage_withhold: number;
    /**
     * Percentage of split votes NO VOTE
     */
    split_votes_percentage_no_vote: number;
    /**
     * Percentage of split votes ONE YEAR
     */
    split_votes_percentage_one_year: number;
    /**
     * Percentage of split votes TWO YEARS
     */
    split_votes_percentage_two_years: number;
    /**
     * Percentage of split votes THREE YEARS
     */
    split_votes_percentage_three_years: number;
    /**
     * Reference to the SVI Proposal being overwritten
     */
    split_vote_instruction_proposal_id: string;
    /**
     * Reportable reason for overwriting the SVI Proposal
     */
    reportable_reason: ReportableReasonEnum;
};

/**
 * * `UNCHANGED` - UNCHANGED
 * * `ADDED` - ADDED
 * * `REMOVED` - REMOVED
 * * `FILTERED` - FILTERED
 */
export const StatusEnum = {
    UNCHANGED: 'UNCHANGED',
    ADDED: 'ADDED',
    REMOVED: 'REMOVED',
    FILTERED: 'FILTERED'
} as const;

/**
 * * `UNCHANGED` - UNCHANGED
 * * `ADDED` - ADDED
 * * `REMOVED` - REMOVED
 * * `FILTERED` - FILTERED
 */
export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];

export type SupportedIssuedInstrumentsQueryRequest = {
    /**
     * List of component differences
     */
    components: Array<ComponentDiffRequest>;
    /**
     * Date at which the supported instruments take effect
     */
    recomposition_date: Date;
    investor_name: string;
    /**
     * Name of the voting policy in format 'votingPolicies/{uuid}'
     */
    voting_policy_name?: string | null;
};

/**
 * Response serializer for task status.
 */
export type TaskStatus = {
    /**
     * Unique task ID
     */
    task_id: number;
    /**
     * Task status (todo, doing, succeeded, failed, cancelled)
     */
    status: string;
    /**
     * Name of the task
     */
    task_name: string;
    /**
     * Queue name
     */
    queue: string;
    /**
     * When task was scheduled
     */
    scheduled_at: Date;
    /**
     * When task started execution
     */
    started_at?: Date | null;
};

/**
 * Response serializer when a task is successfully queued.
 */
export type TaskTriggered = {
    /**
     * Unique task ID for polling status
     */
    task_id: number;
    /**
     * Confirmation message
     */
    message: string;
};

/**
 * Request serializer for triggering entitlements computation.
 */
export type TriggerComputeEntitlementsRequest = {
    /**
     * ID of the proxy intermediary ballot to compute entitlements for
     */
    proxy_intermediary_ballot_id: string;
    /**
     * Optional list of investor IDs to filter entitlements computation. Intended for testing only. If not provided, all investors are included.
     */
    investor_ids?: Array<string>;
};

/**
 * Request serializer for triggering meeting ballot handout processing.
 */
export type TriggerProcessMeetingBallotsRequest = {
    /**
     * ID of the proxy intermediary ballot to process meeting ballots for
     */
    proxy_intermediary_ballot_id: string;
    /**
     * Optional habitat ID to filter meeting ballot processing. Intended for testing only. If not provided, investors for all habitats are processed.
     */
    habitat_id?: string | null;
};

/**
 * * `retail` - Retail
 * * `institutional` - Institutional
 */
export const TypeEnum = { RETAIL: 'retail', INSTITUTIONAL: 'institutional' } as const;

/**
 * * `retail` - Retail
 * * `institutional` - Institutional
 */
export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];

export type UnassociatedInstrumentsResponse = {
    instruments: Array<Instrument>;
};

/**
 * Serializer for voter details response.
 */
export type VoterDetailsResponse = {
    /**
     * Unique identifier for the voter
     */
    id: string;
    /**
     * Broker associated with the voter
     */
    broker_id: string;
};

/**
 * Serializer for voter response without holdings.
 */
export type VoterResponse = {
    /**
     * Unique identifier for a voter
     */
    readonly id: string;
    /**
     * Mediants unique identifier for the voter
     */
    mediant_id: string;
    /**
     * Broker associated with the voter
     */
    broker_id: string;
    /**
     * Type of voter
     *
     * * `retail` - Retail
     * * `institutional` - Institutional
     */
    type: TypeEnum;
    /**
     * Authorization token for the voter
     */
    token: string;
};

/**
 * Serializer for creating or updating a voter with their holdings.
 */
export type VoterWithHoldingsInputRequest = {
    /**
     * Mediants unique identifier for the voter
     */
    mediant_id: string;
    /**
     * Broker associated with the voter
     */
    broker_id: string;
    /**
     * Type of voter
     *
     * * `retail` - Retail
     * * `institutional` - Institutional
     */
    type: TypeEnum;
    /**
     * List of holdings for the voter
     */
    holdings: Array<HoldingInputRequest>;
};

/**
 * Serializer for voter response with holdings.
 */
export type VoterWithHoldingsResponse = {
    /**
     * Unique identifier for a voter
     */
    readonly id: string;
    /**
     * Mediants unique identifier for the voter
     */
    mediant_id: string;
    /**
     * Broker associated with the voter
     */
    broker_id: string;
    /**
     * Type of voter
     *
     * * `retail` - Retail
     * * `institutional` - Institutional
     */
    type: TypeEnum;
    /**
     * Authorization token for the voter
     */
    token: string;
    /**
     * List of holdings for the voter
     */
    readonly holdings: Array<Holding>;
};

/**
 * Serializer for BallotEntitlement responses.
 */
export type BallotEntitlementWritable = {
    proxy_intermediary_ballot_id: string;
    investor_account_id: string;
    ballot_proportion: number;
    investor_supported_issued_instrument_id?: string | null;
    investor_policy_supported_issued_instrument_id?: string | null;
    fund_manager_policy_supported_issued_instrument_id?: string | null;
    invalid_time?: Date | null;
};

export type BatchVoterWithHoldingsResponseWritable = {
    /**
     * Newly created voters
     */
    created: Array<VoterResponseWritable>;
    /**
     * Updated voters
     */
    updated: Array<VoterResponseWritable>;
};

export type FetchMinimalInstrumentsResponseWritable = {
    instruments: Array<MinimalInstrumentWritable>;
};

export type FundManagerWritable = {
    id: string;
    title: string;
    product: string;
    website_url: string | null;
    logo_url: string | null;
    logo_thumbnail_url: string | null;
    relationship_owner: string | null;
    create_time: Date;
    update_time: Date;
};

export type FundManagerPolicySiiWritable = {
    fund_manager_name: string;
    voting_policy_name: string;
    public_security_id_name: string;
    create_time: Date;
    delete_time?: Date | null;
    valid_from: Date;
    valid_to?: Date | null;
};

export type FundManagerPolicySiiResponseWritable = {
    items: Array<FundManagerPolicySiiWritable>;
};

/**
 * Response serializer for batch upserting fund manager supported policies.
 */
export type FundManagerSupportedVotingPolicyBatchUpsertResponseWritable = {
    policies: Array<unknown>;
};

export type HoldingWritable = {
    /**
     * ISIN (International Securities Identification Number). Must be 12-character alphanumeric code.
     */
    isin?: string | null;
    /**
     * Number of shares held
     */
    settled_quantity: number;
    /**
     * CUSIP (Committee on Uniform Securities Identification Procedures) number. A 9-character alphanumeric code that identifies North American financial securities.
     */
    cusip: string;
    /**
     * When the holdings record is valid
     */
    valid_time: Date;
    /**
     * Reference to the voter owning the holdings
     */
    voter_id: string;
};

export type HoldingResponseWritable = {
    /**
     * List of holdings for the voter
     */
    holdings: Array<HoldingWritable>;
};

export type InstrumentWritable = {
    isin: string;
    title: string;
    mifir_identifier_code: string;
    is_composite: boolean;
    cfi: string | null;
};

export type InvestorPolicySiiWritable = {
    voting_policy_name: string;
    public_security_id_name: string;
    create_time: Date;
    delete_time?: Date | null;
    valid_from: Date;
    valid_to?: Date | null;
};

export type InvestorPolicySiiResponseWritable = {
    items: Array<InvestorPolicySiiWritable>;
};

export type InvestorRulesEngineWritable = {
    investor_name: string;
    rules_engine_name?: string | null;
};

export type InvestorSiiResponseWritable = {
    items: Array<InvestorSupportedIssuedInstrumentWritable>;
};

export type InvestorSupportedIssuedInstrumentWritable = {
    public_security_id_name: string;
    create_time: Date;
    delete_time?: Date | null;
    valid_from: Date;
    valid_to?: Date | null;
};

export type MeetingWritable = {
    /**
     * Unique identifier for the general meeting
     */
    general_meeting_id: string;
    /**
     * Date and time when the meeting is scheduled
     */
    meeting_date: Date;
    /**
     * Identifier for the habitat this meeting belongs to
     */
    habitat_id: string;
    /**
     * Unique identifier for the organization holding the meeting
     */
    organization_id: string;
    /**
     * Display name of the organization
     */
    organization_display_title: string;
    /**
     * URL to the organization's logo image
     */
    organization_logo_url?: string | null;
    /**
     * NAICS industry classification title for the organization
     */
    organization_naics_title: string;
    /**
     * Identifier for the meeting ballot
     */
    meeting_ballot_id: string;
    /**
     * Deadline for voting/taking action on meeting proposals
     */
    action_deadline: Date;
    /**
     * Identifier for the investment scheme
     */
    scheme_id: string;
    /**
     * List of theme/classification codes for proposals in this meeting (e.g., CC, OE, PR)
     */
    proposal_classification_codes?: Array<string>;
};

export type MeetingBallotWritable = {
    /**
     * The investor this ballot belongs to
     */
    investor: string;
    /**
     * The habitat this meeting ballot belongs to
     */
    habitat: string;
    /**
     * General meeting this ballot is associated with
     */
    general_meeting: string;
    /**
     * Earliest voting deadline across all PI ballots linked to this meeting ballot
     */
    earliest_voting_deadline: Date;
    /**
     * Latest voting deadline across all PI ballots linked to this meeting ballot
     */
    latest_voting_deadline: Date;
    complete_time?: Date | null;
};

export type MeetingBallotSourceWritable = {
    /**
     * The meeting ballot this source contributes to
     */
    meeting_ballot: string;
    /**
     * The PI ballot whose entitlements contributed to the meeting ballot
     */
    proxy_intermediary_ballot: string;
    /**
     * Investor SII context at the time the source was created
     */
    investor_supported_issued_instrument_id?: string | null;
    /**
     * Investor policy SII context at the time the source was created
     */
    investor_policy_supported_issued_instrument_id?: string | null;
    /**
     * Fund-manager policy SII context at the time the source was created
     */
    fund_manager_policy_supported_issued_instrument_id?: string | null;
    /**
     * When this source was soft-invalidated; NULL for active sources
     */
    invalid_time?: Date | null;
};

export type MinimalInstrumentWritable = {
    isin: string;
    title: string;
    cfi: string | null;
};

export type PaginatedBallotEntitlementListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<BallotEntitlementWritable>;
};

export type PaginatedFundManagerListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<FundManagerWritable>;
};

export type PaginatedFundManagerPolicySiiListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<FundManagerPolicySiiWritable>;
};

export type PaginatedInstrumentListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<InstrumentWritable>;
};

export type PaginatedInvestorPolicySiiListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<InvestorPolicySiiWritable>;
};

export type PaginatedInvestorSupportedIssuedInstrumentListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<InvestorSupportedIssuedInstrumentWritable>;
};

export type PaginatedMeetingBallotListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingBallotWritable>;
};

export type PaginatedMeetingBallotSourceListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingBallotSourceWritable>;
};

export type PaginatedMeetingListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<MeetingWritable>;
};

export type PaginatedPiBallotSearchListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<PiBallotSearchWritable>;
};

export type PaginatedPiMeetingSearchListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<PiMeetingSearchWritable>;
};

export type PaginatedPublicSecurityIdListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<PublicSecurityIdWritable>;
};

export type PaginatedRulesEngineDefinitionListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<RulesEngineDefinitionWritable>;
};

export type PaginatedRulesEngineRuleListWritable = {
    next?: string | null;
    previous?: string | null;
    results: Array<RulesEngineRuleWritable>;
};

/**
 * Serializer for PI ballot search results.
 */
export type PiBallotSearchWritable = {
    /**
     * Unique identifier for this specific version of the ballot
     */
    ballot_version_id: string;
    /**
     * Total number of shares available for voting on this ballot
     */
    available_shares: number;
    /**
     * Unique identity identifier for the ballot across all versions
     */
    ballot_identity_id: string;
    /**
     * External system identifier for the ballot (e.g., from proxy intermediary platform)
     */
    ballot_external_id: string;
    /**
     * Indicates if this is the most recent active version of the ballot
     */
    ballot_version_is_current: boolean;
    /**
     * Total number of ballots associated with the same proxy intermediary meeting
     */
    ballots_per_meeting: number;
    /**
     * Internal identifier for the custodian account holding the shares
     */
    custodian_account_id: string;
    /**
     * Account number assigned by the custodian institution
     */
    custodian_account_number: string;
    /**
     * Descriptive name or title of the custodian account
     */
    custodian_account_title: string;
    /**
     * Indicates if the ballot aligns with the fund manager's voting policy
     */
    fund_manager_policy_supported: boolean;
    /**
     * Name of the fund manager organization that manages the fund
     */
    fund_manager_title?: string | null;
    /**
     * UUID of the fund manager record
     */
    fund_manager_id?: string | null;
    /**
     * Name of the investment fund that owns the shares being voted
     */
    fund_title: string;
    /**
     * Official name of the shareholder meeting (e.g., Annual General Meeting 2024)
     */
    general_meeting_name: string;
    /**
     * Indicates if the ballot aligns with investor voting guidelines
     */
    investor_supported: boolean;
    /**
     * Indicates if the ballot is supported by formal investor policy recommendations
     */
    investor_policy_supported: boolean;
    /**
     * Name of the company or organization holding the shareholder meeting
     */
    organization_title: string;
    /**
     * CUSIP, ISIN, or other public identifier for the security being voted on
     */
    owned_public_security_id: string;
    /**
     * Display name of the proxy intermediary service provider
     */
    proxy_intermediary_title: string;
    /**
     * Meeting identifier where this ballot is being voted on
     */
    proxy_intermediary_meeting_id: string;
    /**
     * Identifier for the proxy intermediary managing this ballot
     */
    proxy_intermediary_id: string;
    /**
     * Indicates if additional validation is needed for split voting scenarios
     */
    split_vote_check_required: boolean;
    /**
     * Cutoff date and time for submitting votes on this ballot
     */
    vote_deadline: Date;
    /**
     * Current state in the voting workflow (e.g. pending, submitted, checked)
     */
    workflow_status: string;
    /**
     * Username of the person who submitted the vote for processing
     */
    workflow_submitter: string;
    /**
     * Username of the person who reviewed and approved the vote submission
     */
    workflow_checker: string;
    /**
     * UUID of the fund record, used to construct the fund resource name
     */
    fund_id?: string | null;
};

/**
 * Serializer for PI meeting search results.
 */
export type PiMeetingSearchWritable = {
    /**
     * Unique identifier for this specific version of the meeting
     */
    meeting_version_id: string;
    /**
     * Unique identity identifier for the meeting across all versions
     */
    meeting_identity_id: string;
    /**
     * Indicates if this is the most recent active version of the meeting
     */
    meeting_version_is_current: boolean;
    /**
     * Meeting identifier within the proxy intermediary system
     */
    proxy_intermediary_meeting_id: string;
    /**
     * Identifier for the proxy intermediary managing this meeting
     */
    proxy_intermediary_id: string;
    /**
     * External system identifier for the meeting (e.g., from proxy intermediary platform)
     */
    meeting_external_id: string;
    /**
     * Name of the company or organization holding the shareholder meeting
     */
    organization_title: string;
    /**
     * Official name of the shareholder meeting (e.g., Annual General Meeting 2024)
     */
    transparency_general_meeting_name: string;
    /**
     * Type of meeting (e.g., Annual General Meeting, Extraordinary General Meeting)
     */
    meeting_type: string;
    /**
     * Date and time when the meeting is scheduled to occur
     */
    meeting_time: Date;
    /**
     * Cutoff date and time for submitting votes for this meeting
     */
    submission_deadline: Date;
    /**
     * Record date for determining shareholder eligibility
     */
    record_date?: Date | null;
    /**
     * Indicates if the meeting contains contested proposals
     */
    is_contested: boolean;
    /**
     * Indicates if split voting is supported for this meeting
     */
    is_split_voting_supported?: boolean | null;
    /**
     * Additional comments or notes about the meeting
     */
    meeting_comment?: string | null;
    /**
     * Reason why the meeting might not be supported
     */
    unsupported_reason?: string | null;
    /**
     * Date and time when the meeting was cancelled, if applicable
     */
    cancel_time?: Date | null;
    /**
     * Array of security identifiers associated with this meeting
     */
    security_ids?: Array<string> | null;
    /**
     * Identifier for the voting operations workflow
     */
    workflow_id?: string | null;
    /**
     * Current state in the voting workflow (e.g. new, ready_for_refinement, successful)
     */
    workflow_status?: string | null;
    /**
     * Username of the person assigned to refine the meeting data
     */
    workflow_refiner?: string | null;
    /**
     * Username of the person assigned to check the meeting data
     */
    workflow_checker?: string | null;
    /**
     * Display name of the proxy intermediary service provider
     */
    proxy_intermediary_title?: string | null;
    /**
     * Indicates if any of the meeting's securities are supported by investor policies
     */
    investor_supported?: boolean;
    /**
     * Indicates if any of the meeting's securities are supported by investor policy guidelines
     */
    investor_policy_supported?: boolean;
    /**
     * Indicates if any of the meeting's securities are supported by fund manager policies
     */
    fund_manager_policy_supported?: boolean;
    /**
     * Number of ballots associated with this meeting
     */
    ballot_count: number;
    /**
     * Indicates if the meeting has associated ballots available for voting
     */
    has_ballots: boolean;
    /**
     * Date and time when the meeting was first created in the proxy intermediary system
     */
    meeting_create_time: Date;
    /**
     * Latest valid_to date across all SIIs for this meeting's securities, or NULL if any SII has no expiry
     */
    latest_valid_to_sii?: Date | null;
    /**
     * the earliest submission deadline for ballots on the meetingnull if no ballots with submission deadlines present
     */
    earliest_ballot_submission_deadline?: Date | null;
};

/**
 * Serializer for a policy.
 */
export type PolicyWritable = {
    /**
     * Title of the voting policy
     */
    title: string;
    /**
     * Title of the voting policy provider
     */
    provider_title: string;
    /**
     * Description of the voting policy in formatted text
     */
    formatted_description?: string | null;
    /**
     * Key referencing the document associated with the voting policy
     */
    document_key?: string | null;
    /**
     * Indicates if the selected policy is currently available on direct outreach
     */
    is_available?: boolean | null;
};

/**
 * Serializer for policy response.
 */
export type PolicyResponseWritable = {
    /**
     * Identifier to be shared externally with integrated parties
     */
    external_id: string;
    /**
     * Title of the voting policy
     */
    title: string;
    /**
     * Title of the voting policy provider
     */
    provider_title: string;
    /**
     * Description of the voting policy in formatted text
     */
    formatted_description?: string | null;
    /**
     * Key referencing the document associated with the voting policy
     */
    document_key?: string | null;
    /**
     * Indicates if the selected policy is currently available on direct outreach
     */
    is_available?: boolean | null;
};

export type PublicSecurityIdWritable = {
    create_time: Date;
};

/**
 * Read serializer for RulesEngineDefinition.
 */
export type RulesEngineDefinitionWritable = {
    name: string;
    valid_from: Date;
};

/**
 * Read serializer for RulesEngineRule.
 */
export type RulesEngineRuleWritable = {
    rule_type: RuleTypeEnum;
    order: number;
    parameters: unknown;
};

export type SelectedPolicyWritable = {
    /**
     * Reference to the voter selecting the policy
     */
    voter_id: string;
    /**
     * Reference to the selected policy
     */
    policy_id: string;
};

/**
 * Serializer for the selected policy response wrapper.
 */
export type SelectedPolicyResponseWritable = {
    /**
     * The voter's selected policy, or null if none selected
     */
    selectedPolicy: SelectedPolicyWritable | null;
};

export type SplitVoteInstructionProposalOverwriteWritable = {
    /**
     * Internal reason for the overwrite, not reportable
     */
    internal_reason?: string | null;
    /**
     * Author of the overwrite
     */
    author: string;
    /**
     * Investor votes FOR
     */
    investor_votes_for: number;
    /**
     * Investor votes AGAINST
     */
    investor_votes_against: number;
    /**
     * Investor votes ABSTAIN
     */
    investor_votes_abstain: number;
    /**
     * Investor votes WITHHOLD
     */
    investor_votes_withhold: number;
    /**
     * Investor votes NO VOTE
     */
    investor_votes_no_vote: number;
    /**
     * Investor votes ONE YEAR
     */
    investor_votes_one_year: number;
    /**
     * Investor votes TWO YEARS
     */
    investor_votes_two_years: number;
    /**
     * Investor votes THREE YEARS
     */
    investor_votes_three_years: number;
    /**
     * Split votes FOR
     */
    split_votes_for: number;
    /**
     * Split votes AGAINST
     */
    split_votes_against: number;
    /**
     * Split votes ABSTAIN
     */
    split_votes_abstain: number;
    /**
     * Split votes WITHHOLD
     */
    split_votes_withhold: number;
    /**
     * Split votes NO VOTE
     */
    split_votes_no_vote: number;
    /**
     * Split votes ONE YEAR
     */
    split_votes_one_year: number;
    /**
     * Split votes TWO YEARS
     */
    split_votes_two_years: number;
    /**
     * Split votes THREE YEARS
     */
    split_votes_three_years: number;
    /**
     * Percentage of split votes FOR
     */
    split_votes_percentage_for: number;
    /**
     * Percentage of split votes AGAINST
     */
    split_votes_percentage_against: number;
    /**
     * Percentage of split votes ABSTAIN
     */
    split_votes_percentage_abstain: number;
    /**
     * Percentage of split votes WITHHOLD
     */
    split_votes_percentage_withhold: number;
    /**
     * Percentage of split votes NO VOTE
     */
    split_votes_percentage_no_vote: number;
    /**
     * Percentage of split votes ONE YEAR
     */
    split_votes_percentage_one_year: number;
    /**
     * Percentage of split votes TWO YEARS
     */
    split_votes_percentage_two_years: number;
    /**
     * Percentage of split votes THREE YEARS
     */
    split_votes_percentage_three_years: number;
    /**
     * Reference to the SVI Proposal being overwritten
     */
    split_vote_instruction_proposal_id: string;
    /**
     * Reportable reason for overwriting the SVI Proposal
     */
    reportable_reason: ReportableReasonEnum;
};

export type UnassociatedInstrumentsResponseWritable = {
    instruments: Array<InstrumentWritable>;
};

/**
 * Serializer for voter response without holdings.
 */
export type VoterResponseWritable = {
    /**
     * Mediants unique identifier for the voter
     */
    mediant_id: string;
    /**
     * Broker associated with the voter
     */
    broker_id: string;
    /**
     * Type of voter
     *
     * * `retail` - Retail
     * * `institutional` - Institutional
     */
    type: TypeEnum;
    /**
     * Authorization token for the voter
     */
    token: string;
};

/**
 * Serializer for voter response with holdings.
 */
export type VoterWithHoldingsResponseWritable = {
    /**
     * Mediants unique identifier for the voter
     */
    mediant_id: string;
    /**
     * Broker associated with the voter
     */
    broker_id: string;
    /**
     * Type of voter
     *
     * * `retail` - Retail
     * * `institutional` - Institutional
     */
    type: TypeEnum;
    /**
     * Authorization token for the voter
     */
    token: string;
};

export type ApiSchemaRetrieveData = {
    body?: never;
    path?: never;
    query?: {
        format?: 'json' | 'yaml';
        lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'ckb' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'ms' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'ug' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant';
    };
    url: '/api/schema/';
};

export type ApiSchemaRetrieveResponses = {
    200: {
        [key: string]: unknown;
    };
};

export type ApiSchemaRetrieveResponse = ApiSchemaRetrieveResponses[keyof ApiSchemaRetrieveResponses];

export type BackgroundTasksTasksRetrieveData = {
    body?: never;
    path: {
        task_id: number;
    };
    query?: never;
    url: '/background-tasks/tasks/{task_id}/';
};

export type BackgroundTasksTasksRetrieveErrors = {
    /**
     * No response body
     */
    404: unknown;
};

export type BackgroundTasksTasksRetrieveResponses = {
    200: TaskStatus;
};

export type BackgroundTasksTasksRetrieveResponse = BackgroundTasksTasksRetrieveResponses[keyof BackgroundTasksTasksRetrieveResponses];

export type DirectoutreachBetanxtVoterPolicySnapshotExportCreateData = {
    body?: never;
    path?: never;
    query: {
        /**
         * ISO 8601 datetime with timezone for which to export holdings. Must include timezone (e.g., '2024-01-15T10:30:00Z' or '2024-01-15T10:30:00+00:00'). When multiple holdings exist for the same date, selects the most recent by create_time.
         */
        valid_time: string;
    };
    url: '/directoutreach/betanxt/voter-policy-snapshot:export/';
};

export type DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses = {
    200: ExportResult;
};

export type DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponse = DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses[keyof DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses];

export type DirectoutreachPolicyCreateData = {
    body: PolicyRequest;
    path?: never;
    query?: never;
    url: '/directoutreach/policy/';
};

export type DirectoutreachPolicyCreateResponses = {
    201: Policy;
};

export type DirectoutreachPolicyCreateResponse = DirectoutreachPolicyCreateResponses[keyof DirectoutreachPolicyCreateResponses];

export type DirectoutreachPolicyAvailableListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/directoutreach/policy/available/';
};

export type DirectoutreachPolicyAvailableListResponses = {
    200: Array<PolicyResponse>;
};

export type DirectoutreachPolicyAvailableListResponse = DirectoutreachPolicyAvailableListResponses[keyof DirectoutreachPolicyAvailableListResponses];

export type DirectoutreachPolicyAvailableRetrieveData = {
    body?: never;
    path: {
        /**
         * Unique identifier for the policy
         */
        id: string;
    };
    query?: never;
    url: '/directoutreach/policy/available/{id}/';
};

export type DirectoutreachPolicyAvailableRetrieveResponses = {
    200: PolicyResponse;
};

export type DirectoutreachPolicyAvailableRetrieveResponse = DirectoutreachPolicyAvailableRetrieveResponses[keyof DirectoutreachPolicyAvailableRetrieveResponses];

export type DirectoutreachVotersRetrieveData = {
    body?: never;
    path: {
        /**
         * Unique identifier for a voter
         */
        id: string;
    };
    query?: never;
    url: '/directoutreach/voters/{id}/';
};

export type DirectoutreachVotersRetrieveErrors = {
    /**
     * No response body
     */
    404: unknown;
};

export type DirectoutreachVotersRetrieveResponses = {
    200: VoterDetailsResponse;
};

export type DirectoutreachVotersRetrieveResponse = DirectoutreachVotersRetrieveResponses[keyof DirectoutreachVotersRetrieveResponses];

export type DirectoutreachVotersHoldingsRetrieveData = {
    body?: never;
    path: {
        /**
         * Unique identifier for a voter
         */
        id: string;
    };
    query?: never;
    url: '/directoutreach/voters/{id}/holdings/';
};

export type DirectoutreachVotersHoldingsRetrieveErrors = {
    /**
     * No response body
     */
    404: unknown;
};

export type DirectoutreachVotersHoldingsRetrieveResponses = {
    200: HoldingResponse;
};

export type DirectoutreachVotersHoldingsRetrieveResponse = DirectoutreachVotersHoldingsRetrieveResponses[keyof DirectoutreachVotersHoldingsRetrieveResponses];

export type DirectoutreachVotersSelectedPolicyRetrieveData = {
    body?: never;
    path: {
        /**
         * Unique identifier for a voter
         */
        id: string;
    };
    query?: never;
    url: '/directoutreach/voters/{id}/selected-policy/';
};

export type DirectoutreachVotersSelectedPolicyRetrieveErrors = {
    /**
     * No response body
     */
    404: unknown;
};

export type DirectoutreachVotersSelectedPolicyRetrieveResponses = {
    200: SelectedPolicyResponse;
};

export type DirectoutreachVotersSelectedPolicyRetrieveResponse = DirectoutreachVotersSelectedPolicyRetrieveResponses[keyof DirectoutreachVotersSelectedPolicyRetrieveResponses];

export type DirectoutreachVotersSelectedPolicyCreateData = {
    body: SelectedPolicyRequestRequest;
    path: {
        /**
         * Unique identifier for a voter
         */
        id: string;
    };
    query?: never;
    url: '/directoutreach/voters/{id}/selected-policy/';
};

export type DirectoutreachVotersSelectedPolicyCreateErrors = {
    /**
     * No response body
     */
    400: unknown;
    /**
     * No response body
     */
    404: unknown;
};

export type DirectoutreachVotersSelectedPolicyCreateResponses = {
    201: SelectedPolicyResponse;
};

export type DirectoutreachVotersSelectedPolicyCreateResponse = DirectoutreachVotersSelectedPolicyCreateResponses[keyof DirectoutreachVotersSelectedPolicyCreateResponses];

export type DirectoutreachVotersBatchCreateCreateData = {
    body: BatchVoterWithHoldingsInputRequest;
    path?: never;
    query?: never;
    url: '/directoutreach/voters:batch-create/';
};

export type DirectoutreachVotersBatchCreateCreateErrors = {
    /**
     * Validation error - no voters created
     */
    400: unknown;
    /**
     * Server error - no voters created
     */
    500: unknown;
};

export type DirectoutreachVotersBatchCreateCreateResponses = {
    200: BatchVoterWithHoldingsResponse;
    201: BatchVoterWithHoldingsResponse;
};

export type DirectoutreachVotersBatchCreateCreateResponse = DirectoutreachVotersBatchCreateCreateResponses[keyof DirectoutreachVotersBatchCreateCreateResponses];

export type DirectoutreachVotersCreateCreateData = {
    body: VoterWithHoldingsInputRequest;
    path?: never;
    query?: never;
    url: '/directoutreach/voters:create/';
};

export type DirectoutreachVotersCreateCreateResponses = {
    200: VoterWithHoldingsResponse;
    201: VoterWithHoldingsResponse;
};

export type DirectoutreachVotersCreateCreateResponse = DirectoutreachVotersCreateCreateResponses[keyof DirectoutreachVotersCreateCreateResponses];

export type FundManagerFundManagersListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        names?: Array<string>;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Filter by product (PTV or Shareholder).
         */
        product?: string;
        relationship_owners?: Array<string>;
        /**
         * Case-insensitive substring match on title.
         */
        search_title?: string;
    };
    url: '/fund-manager/fund-managers/';
};

export type FundManagerFundManagersListResponses = {
    200: PaginatedFundManagerList;
};

export type FundManagerFundManagersListResponse = FundManagerFundManagersListResponses[keyof FundManagerFundManagersListResponses];

export type FundManagerFundManagersCreateData = {
    body: FundManagerWriteRequest;
    path?: never;
    query?: never;
    url: '/fund-manager/fund-managers/';
};

export type FundManagerFundManagersCreateResponses = {
    201: FundManager;
};

export type FundManagerFundManagersCreateResponse = FundManagerFundManagersCreateResponses[keyof FundManagerFundManagersCreateResponses];

export type FundManagerFundManagersRetrieveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/fund-manager/fund-managers/{id}/';
};

export type FundManagerFundManagersRetrieveResponses = {
    200: FundManager;
};

export type FundManagerFundManagersRetrieveResponse = FundManagerFundManagersRetrieveResponses[keyof FundManagerFundManagersRetrieveResponses];

export type FundManagerFundManagersUpdateData = {
    body: FundManagerWriteRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/fund-manager/fund-managers/{id}/';
};

export type FundManagerFundManagersUpdateResponses = {
    200: FundManager;
};

export type FundManagerFundManagersUpdateResponse = FundManagerFundManagersUpdateResponses[keyof FundManagerFundManagersUpdateResponses];

export type InstitutionalMeetingsearchListData = {
    body?: never;
    path?: never;
    query: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Search for organizations by display title (case insensitive)
         */
        organization_title_search?: string;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Scheme name in format 'habitats/{habitat_id}/schemes/{scheme_id}'
         */
        scheme_name: string;
        /**
         * Sort order by voting deadline (action_deadline). 'asc' shows meetings with soonest deadlines first. Default is 'asc'.
         */
        sort_order?: 'asc' | 'desc';
        /**
         * Filter meetings by status.
         * Note:
         * 'OPEN' status filters for Meetings that have an 'Action Deadline' of 00:01:00 today.
         * 'CLOSED' status filters for Meetings that have an 'Action Deadline'
         * before 'now' and a 'Meeting Date' after 'now'.
         * 'ALL' status filters for Meetings that have a 'Meeting Date' after 'now'.
         */
        status?: 'all' | 'closed' | 'open';
        /**
         * Comma-separated list of theme codes to filter by
         */
        theme_codes?: string;
    };
    url: '/institutional/meetingsearch';
};

export type InstitutionalMeetingsearchListResponses = {
    200: PaginatedMeetingList;
};

export type InstitutionalMeetingsearchListResponse = InstitutionalMeetingsearchListResponses[keyof InstitutionalMeetingsearchListResponses];

export type ProxyvotingEntitlementsListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Include invalidated entitlements (default: false, only returns active entitlements).
         */
        include_invalid?: boolean;
        /**
         * Filter by investor account UUID - exact match.
         */
        investor_account_id?: string;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Filter by proxy intermediary ballot UUID - exact match.
         */
        proxy_intermediary_ballot_id?: string;
    };
    url: '/proxyvoting/entitlements';
};

export type ProxyvotingEntitlementsListResponses = {
    200: PaginatedBallotEntitlementList;
};

export type ProxyvotingEntitlementsListResponse = ProxyvotingEntitlementsListResponses[keyof ProxyvotingEntitlementsListResponses];

export type ProxyvotingEntitlementsBreakdownCreateData = {
    body: ComputeBreakdownRequestRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/entitlements/breakdown';
};

export type ProxyvotingEntitlementsBreakdownCreateResponses = {
    200: BreakdownResponse;
};

export type ProxyvotingEntitlementsBreakdownCreateResponse = ProxyvotingEntitlementsBreakdownCreateResponses[keyof ProxyvotingEntitlementsBreakdownCreateResponses];

export type ProxyvotingEntitlementsComputeCreateData = {
    body: TriggerComputeEntitlementsRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/entitlements:compute';
};

export type ProxyvotingEntitlementsComputeCreateResponses = {
    202: TaskTriggered;
};

export type ProxyvotingEntitlementsComputeCreateResponse = ProxyvotingEntitlementsComputeCreateResponses[keyof ProxyvotingEntitlementsComputeCreateResponses];

export type ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData = {
    body: FundManagerSupportedIssuedInstrumentsQueryRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/fund-manager/compositions/sii/from-composition-difference';
};

export type ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses = {
    /**
     * No response body
     */
    200: unknown;
};

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Filter by fund manager names in the format `fundManagers/{uuid}`.
         */
        fund_manager_names?: Array<string>;
        /**
         * Filter by whether to include deleted FundManagerPolicySupportedIssuedInstruments. Defaults to false.
         */
        include_deleted?: boolean;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Filter by public security ID names in the format `securityIDTypes/{type}/securityIDs/{value}`.
         */
        public_security_id_names?: Array<string>;
        /**
         * Filter for supported instruments with a valid_from time on or after the specified time (ISO 8601).
         */
        valid_from_after?: string;
        /**
         * Filter for supported instruments with a valid_from time before the specified time (ISO 8601).
         */
        valid_from_before?: string;
        /**
         * Filter for supported instruments with a valid_to time on or after the specified time (ISO 8601), including instruments with an unspecified valid_to time.
         */
        valid_to_after?: string;
        /**
         * Filter for supported instruments with a valid_to time before the specified time (ISO 8601). Instruments with an unspecified valid_to time are excluded.
         */
        valid_to_before?: string;
        /**
         * Filter by voting policy names in the format `votingPolicies/{uuid}`.
         */
        voting_policy_names?: Array<string>;
    };
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments';
};

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponses = {
    200: PaginatedFundManagerPolicySiiList;
};

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponse = ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponses[keyof ProxyvotingFundManagerPolicySupportedIssuedInstrumentsListResponses];

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData = {
    body: FundManagerPolicySiiBatchCreateRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments';
};

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses = {
    200: FundManagerPolicySiiResponse;
};

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponse = ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses[keyof ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses];

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData = {
    body: FundManagerPolicySiiBatchDeleteRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments/batch-delete';
};

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponse = ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses[keyof ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses];

export type ProxyvotingFundManagerSupportedPoliciesListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Return the state of policies as they were at this datetime (ISO 8601). Returns historical records.
         */
        as_of?: Date;
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Filter by FundManager UUID - exact match.
         */
        fund_manager_id?: string;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        voting_policy_id?: Array<string>;
    };
    url: '/proxyvoting/fund-manager/supported-policies';
};

export type ProxyvotingFundManagerSupportedPoliciesListResponses = {
    200: PaginatedFundManagerSupportedVotingPolicyHistoricalList;
};

export type ProxyvotingFundManagerSupportedPoliciesListResponse = ProxyvotingFundManagerSupportedPoliciesListResponses[keyof ProxyvotingFundManagerSupportedPoliciesListResponses];

export type ProxyvotingFundManagerSupportedPoliciesCreateData = {
    body: FundManagerSupportedVotingPolicyBatchUpsertRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/fund-manager/supported-policies';
};

export type ProxyvotingFundManagerSupportedPoliciesCreateResponses = {
    200: FundManagerSupportedVotingPolicyBatchUpsertResponse;
};

export type ProxyvotingFundManagerSupportedPoliciesCreateResponse = ProxyvotingFundManagerSupportedPoliciesCreateResponses[keyof ProxyvotingFundManagerSupportedPoliciesCreateResponses];

export type ProxyvotingFundManagerSupportedPoliciesDestroyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/proxyvoting/fund-manager/supported-policies/{id}';
};

export type ProxyvotingFundManagerSupportedPoliciesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ProxyvotingFundManagerSupportedPoliciesDestroyResponse = ProxyvotingFundManagerSupportedPoliciesDestroyResponses[keyof ProxyvotingFundManagerSupportedPoliciesDestroyResponses];

export type ProxyvotingInvestorCompositionsDifferenceListData = {
    body?: never;
    path?: never;
    query: {
        /**
         * latest composition date time
         */
        end_time: string;
        /**
         * Investors to fetch compositions for
         */
        investor_names: Array<string>;
        /**
         * original composition date time
         */
        start_time: string;
    };
    url: '/proxyvoting/investor/compositions/difference';
};

export type ProxyvotingInvestorCompositionsDifferenceListResponses = {
    200: Array<CompositionDifferenceResponse>;
};

export type ProxyvotingInvestorCompositionsDifferenceListResponse = ProxyvotingInvestorCompositionsDifferenceListResponses[keyof ProxyvotingInvestorCompositionsDifferenceListResponses];

export type ProxyvotingInvestorCompositionsRenderCreateData = {
    body: RenderCompositionDifferenceRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/investor/compositions/render';
};

export type ProxyvotingInvestorCompositionsRenderCreateResponses = {
    200: Blob | File;
};

export type ProxyvotingInvestorCompositionsRenderCreateResponse = ProxyvotingInvestorCompositionsRenderCreateResponses[keyof ProxyvotingInvestorCompositionsRenderCreateResponses];

export type ProxyvotingInvestorCompositionsRulesEngineRetrieveData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Investor resource name in format habitats/{habitat_id}/investors/{investor_id}
         */
        investor_name: string;
    };
    url: '/proxyvoting/investor/compositions/rules-engine';
};

export type ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses = {
    200: InvestorRulesEngine;
};

export type ProxyvotingInvestorCompositionsRulesEngineRetrieveResponse = ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses[keyof ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses];

export type ProxyvotingInvestorCompositionsRulesEngineUpdateData = {
    body: InvestorRulesEngineRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/investor/compositions/rules-engine';
};

export type ProxyvotingInvestorCompositionsRulesEngineUpdateResponses = {
    200: InvestorRulesEngine;
    201: InvestorRulesEngine;
};

export type ProxyvotingInvestorCompositionsRulesEngineUpdateResponse = ProxyvotingInvestorCompositionsRulesEngineUpdateResponses[keyof ProxyvotingInvestorCompositionsRulesEngineUpdateResponses];

export type ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData = {
    body: SupportedIssuedInstrumentsQueryRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/investor/compositions/sii/from-composition-difference';
};

export type ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses = {
    /**
     * No response body
     */
    200: unknown;
};

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Filter by whether to include deleted InvestorPolicySupportedIssuedInstruments. Defaults to false.
         */
        include_deleted?: boolean;
        /**
         * Filter by investor names in the format `habitats/{uuid}/investors/{uuid}`.
         */
        investor_names?: Array<string>;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Filter by public security ID names in the format `securityIDTypes/{type}/securityIDs/{value}`.
         */
        public_security_id_names?: Array<string>;
        /**
         * Filter for supported instruments with a valid_from time on or after the specified time (ISO 8601).
         */
        valid_from_after?: string;
        /**
         * Filter for supported instruments with a valid_from time before the specified time (ISO 8601).
         */
        valid_from_before?: string;
        /**
         * Filter for supported instruments with a valid_to time on or after the specified time (ISO 8601), including instruments with an unspecified valid_to time.
         */
        valid_to_after?: string;
        /**
         * Filter for supported instruments with a valid_to time before the specified time (ISO 8601). Instruments with an unspecified valid_to time are excluded.
         */
        valid_to_before?: string;
        /**
         * Filter by voting policy names in the format `votingPolicies/{uuid}`.
         */
        voting_policy_names?: Array<string>;
    };
    url: '/proxyvoting/investor/policy-supported-issued-instruments';
};

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsListResponses = {
    200: PaginatedInvestorPolicySiiList;
};

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsListResponse = ProxyvotingInvestorPolicySupportedIssuedInstrumentsListResponses[keyof ProxyvotingInvestorPolicySupportedIssuedInstrumentsListResponses];

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData = {
    body: InvestorPolicySiiBatchCreateRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/investor/policy-supported-issued-instruments';
};

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses = {
    200: InvestorPolicySiiResponse;
};

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponse = ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses[keyof ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses];

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData = {
    body: InvestorPolicySiiBatchDeleteRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/investor/policy-supported-issued-instruments/batch-delete';
};

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponse = ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses[keyof ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses];

export type ProxyvotingInvestorSupportedIssuedInstrumentsListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Filter by whether to include deleted InvestorSupportedIssuedInstruments. Defaults to false.
         */
        include_deleted?: boolean;
        /**
         * Filter by investor names in the format `habitats/{uuid}/investors/{uuid}`.
         */
        investor_names?: Array<string>;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Filter by public security ID names in the format `securityIDTypes/{type}/securityIDs/{value}`.
         */
        public_security_id_names?: Array<string>;
        /**
         * Filter for supported instruments with a valid_from time on or after the specified time (ISO 8601).
         */
        valid_from_after?: string;
        /**
         * Filter for supported instruments with a valid_from time before the specified time (ISO 8601).
         */
        valid_from_before?: string;
        /**
         * Filter for supported instruments with a valid_to time on or after the specified time (ISO 8601), including instruments with an unspecified valid_to time.
         */
        valid_to_after?: string;
        /**
         * Filter for supported instruments with a valid_to time before the specified time (ISO 8601). Instruments with an unspecified valid_to time are excluded.
         */
        valid_to_before?: string;
    };
    url: '/proxyvoting/investor/supported-issued-instruments';
};

export type ProxyvotingInvestorSupportedIssuedInstrumentsListResponses = {
    200: PaginatedInvestorSupportedIssuedInstrumentList;
};

export type ProxyvotingInvestorSupportedIssuedInstrumentsListResponse = ProxyvotingInvestorSupportedIssuedInstrumentsListResponses[keyof ProxyvotingInvestorSupportedIssuedInstrumentsListResponses];

export type ProxyvotingInvestorSupportedIssuedInstrumentsCreateData = {
    body: InvestorSiiBatchCreateRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/investor/supported-issued-instruments';
};

export type ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses = {
    200: InvestorSiiResponse;
};

export type ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponse = ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses[keyof ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses];

export type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData = {
    body: InvestorSiiBatchDeleteRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/investor/supported-issued-instruments/batch-delete';
};

export type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponse = ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses[keyof ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses];

export type ProxyvotingMeetingBallotSourcesListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Include invalidated sources (default: false, only returns active sources).
         */
        include_invalid?: boolean;
        /**
         * Filter by meeting ballot id.
         */
        meeting_ballot_id?: string;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Filter by proxy intermediary ballot id.
         */
        proxy_intermediary_ballot_id?: string;
    };
    url: '/proxyvoting/meeting-ballot-sources';
};

export type ProxyvotingMeetingBallotSourcesListResponses = {
    200: PaginatedMeetingBallotSourceList;
};

export type ProxyvotingMeetingBallotSourcesListResponse = ProxyvotingMeetingBallotSourcesListResponses[keyof ProxyvotingMeetingBallotSourcesListResponses];

export type ProxyvotingMeetingBallotsListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Filter by general meeting id.
         */
        general_meeting_id?: string;
        /**
         * Filter by investor id.
         */
        investor_id?: string;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
    };
    url: '/proxyvoting/meeting-ballots';
};

export type ProxyvotingMeetingBallotsListResponses = {
    200: PaginatedMeetingBallotList;
};

export type ProxyvotingMeetingBallotsListResponse = ProxyvotingMeetingBallotsListResponses[keyof ProxyvotingMeetingBallotsListResponses];

export type ProxyvotingMeetingballotsComputeCreateData = {
    body: TriggerProcessMeetingBallotsRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/meetingballots:compute';
};

export type ProxyvotingMeetingballotsComputeCreateResponses = {
    202: TaskTriggered;
};

export type ProxyvotingMeetingballotsComputeCreateResponse = ProxyvotingMeetingballotsComputeCreateResponses[keyof ProxyvotingMeetingballotsComputeCreateResponses];

export type ProxyvotingPiballotsFilterListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Filter ballots by workflow checker email - exact string match.
         */
        checker?: string;
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Custodian account identifier - exact string match.
         */
        custodian_account_number?: string;
        /**
         * External ballot identifier - exact string match.
         */
        external_id?: string;
        /**
         * Filter ballots by fund manager title - case-insensitive substring match.
         */
        fund_manager_title?: string;
        /**
         * Filter ballots by fund title - case-insensitive substring match.
         */
        fund_title?: string;
        /**
         * Filter ballots by whether they have a workflow checker email assigned. True for ballots with checker, False for ballots without checker, omit for all.
         */
        has_checker?: boolean;
        /**
         * Filter ballots by whether they have a workflow submitter email assigned. True for ballots with submitter, False for ballots without submitter, omit for all.
         */
        has_submitter?: boolean;
        /**
         * Filter ballots by scope. True for in-scope (any policy support field is true), False for out-of-scope (all policy support fields are false), omit for all.
         */
        in_scope?: boolean;
        /**
         * ISIN (International Securities Identification Number) - exact match filter. Must be 12-character alphanumeric code.
         */
        isin?: string;
        /**
         * Filter ballots by whether they are linked to a general meeting. True for linked, False for unlinked, omit for all.
         */
        linked?: boolean;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * Filter ballots by organization title - case-insensitive substring match.
         */
        organization_title?: string;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Filter ballots by whether the 'proxy_intermediary_id' and 'proxy_intermediary_meeting_id' match the provided meeting name.
         * Expected format:'proxyIntermediaries/{proxy_intermediary_id}/meetings/{proxy_intermediary_meeting_id}'
         */
        pi_meeting_name?: string;
        /**
         * Proxy intermediary(s) managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
         *
         * * `Proxymity` - Proxymity
         * * `ProxyEdge` - ProxyEdge
         * * `ProxyExchange` - ProxyExchange
         */
        proxy_intermediaries?: Array<'ProxyEdge' | 'ProxyExchange' | 'Proxymity'>;
        /**
         * Filter ballots by proxy intermediary title - exact string match.
         */
        proxy_intermediary?: string;
        /**
         * General search across organization title, ballot external ID, and ISIN - case-insensitive substring match.
         */
        search?: string;
        /**
         * Filter ballots by whether split vote checking is required. True for required, False for not required, omit for all.
         */
        split_vote_check_required?: boolean;
        /**
         * Filter ballots by workflow status. Multiple values can be selected to match any of the specified statuses.
         *
         * * `invalid` - Invalid
         * * `not_submitted_in_testing` - Not Submitted in Testing
         * * `not_submitted_unvoted` - Not Submitted Unvoted
         * * `not_submitted_no_entitlements` - Not Submitted No Entitlements
         * * `not_submitted_undefined` - Not Submitted Undefined
         * * `needs_attention` - Needs Attention
         * * `ineligible` - Ineligible
         * * `cancelled` - Cancelled
         * * `meeting_needs_refining` - Meeting Needs Refining
         * * `meeting_voting_enabled` - Meeting Voting Enabled
         * * `entitled_to_vote` - Entitled to Vote
         * * `ready_for_split_vote` - Ready for Split Vote
         * * `late_vote_process` - Late Vote Process
         * * `split_vote_awaiting_check` - Split Vote Awaiting Check
         * * `split_vote_submitted` - Split Vote Submitted
         * * `successful` - Successful
         * * `rejected` - Rejected
         * * `overridden` - Overridden
         * * `in_testing` - In Testing
         */
        status?: Array<'cancelled' | 'entitled_to_vote' | 'in_testing' | 'ineligible' | 'invalid' | 'late_vote_process' | 'meeting_needs_refining' | 'meeting_voting_enabled' | 'needs_attention' | 'not_submitted_in_testing' | 'not_submitted_no_entitlements' | 'not_submitted_undefined' | 'not_submitted_unvoted' | 'overridden' | 'ready_for_split_vote' | 'rejected' | 'split_vote_awaiting_check' | 'split_vote_submitted' | 'successful'>;
        /**
         * Filter ballots by workflow submitter email - exact string match.
         */
        submitter?: string;
        /**
         * Filter ballots with vote deadline after or equal to this UTC datetime.
         */
        vote_deadline_after?: Date;
        /**
         * Filter ballots with vote deadline before or equal to this UTC datetime.
         */
        vote_deadline_before?: Date;
    };
    url: '/proxyvoting/piballots/filter';
};

export type ProxyvotingPiballotsFilterListResponses = {
    200: PaginatedPiBallotSearchList;
};

export type ProxyvotingPiballotsFilterListResponse = ProxyvotingPiballotsFilterListResponses[keyof ProxyvotingPiballotsFilterListResponses];

export type ProxyvotingPiballotsInvestorsCanVoteCreateData = {
    body: InvestorsCanVoteRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/piballots/investors-can-vote';
};

export type ProxyvotingPiballotsInvestorsCanVoteCreateResponses = {
    200: InvestorsCanVoteResponse;
};

export type ProxyvotingPiballotsInvestorsCanVoteCreateResponse = ProxyvotingPiballotsInvestorsCanVoteCreateResponses[keyof ProxyvotingPiballotsInvestorsCanVoteCreateResponses];

export type ProxyvotingPimeetingsFilterListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Filter meetings by assigned checker user email address - exact match.
         */
        assigned_checker_user_id?: string;
        /**
         * Filter meetings by assigned refiner user email address - exact match.
         */
        assigned_refiner_user_id?: string;
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Filter meetings with earliest ballot submission deadline is after or equal to this UTC datetime,
         */
        earliest_ballot_submission_deadline_after?: Date;
        /**
         * Filter meetings with earliest ballot submission before or equal to this UTC datetime.
         */
        earliest_ballot_submission_deadline_before?: Date;
        /**
         * Filter meetings by ballot presence. True for meetings with ballots, False for meetings without ballots, omit for all.
         */
        has_ballots?: boolean;
        /**
         * Filter meetings by checker presence. True for meetings with checker, False for meetings without checker, omit for all.
         */
        has_checker?: boolean;
        /**
         * Filter meetings by refiner presence. True for meetings with refiner, False for meetings without refiner, omit for all.
         */
        has_refiner?: boolean;
        /**
         * Filter meetings by scope. True for in-scope (any policy support field is true), False for out-of-scope (all policy support fields are false), omit for all.
         */
        in_scope?: boolean;
        /**
         * Filter meetings by whether they are linked to Tumelo meetings. True for linked, False for unlinked, omit for all.
         */
        linked_to_tumelo_meeting?: boolean;
        /**
         * Filter meetings created after or equal to this UTC datetime.
         */
        meeting_create_time_after?: Date;
        /**
         * Filter meetings created before or equal to this UTC datetime.
         */
        meeting_create_time_before?: Date;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Proxy intermediary(s) managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
         *
         * * `Proxymity` - Proxymity
         * * `ProxyEdge` - ProxyEdge
         * * `ProxyExchange` - ProxyExchange
         */
        proxy_intermediaries?: Array<'ProxyEdge' | 'ProxyExchange' | 'Proxymity'>;
        /**
         * Proxy intermediary managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
         *
         * * `Proxymity` - Proxymity
         * * `ProxyEdge` - ProxyEdge
         * * `ProxyExchange` - ProxyExchange
         */
        proxy_intermediary?: 'ProxyEdge' | 'ProxyExchange' | 'Proxymity';
        /**
         * General search across meeting external ID, organization title, and security IDs - case-insensitive substring match. Maximum 255 characters.
         */
        search?: string;
        /**
         * Filter meetings by workflow status. Multiple values can be selected to match any of the specified statuses.
         *
         * * `invalid` - Invalid
         * * `new` - New
         * * `unlinked` - Unlinked
         * * `unsupported` - Unsupported
         * * `needs_attention` - Needs Attention
         * * `cancelled` - Cancelled
         * * `cancellation_incomplete` - Cancellation Incomplete
         * * `ready_for_refinement` - Ready for Refinement
         * * `refinement_complete` - Refinement Complete
         * * `manual_voting_enabled` - Manual Voting Enabled
         * * `entitled_to_vote` - Entitled to Vote
         * * `ready_for_split_vote` - Ready for Split Vote
         * * `split_vote_submitted` - Split Vote Submitted
         * * `successful` - Successful
         * * `rejected` - Rejected
         * * `overridden` - Overridden
         * * `partial_success` - Partial Success
         */
        status?: Array<'cancellation_incomplete' | 'cancelled' | 'entitled_to_vote' | 'invalid' | 'manual_voting_enabled' | 'needs_attention' | 'new' | 'overridden' | 'partial_success' | 'ready_for_refinement' | 'ready_for_split_vote' | 'refinement_complete' | 'rejected' | 'split_vote_submitted' | 'successful' | 'unlinked' | 'unsupported'>;
        /**
         * Filter meetings with submission deadline after or equal to this UTC datetime, where the latest valid_to SII date is before this datetime, with an 8 month buffer.
         */
        submission_deadline_after?: Date;
        /**
         * Filter meetings with submission deadline before or equal to this UTC datetime.
         */
        submission_deadline_before?: Date;
    };
    url: '/proxyvoting/pimeetings/filter';
};

export type ProxyvotingPimeetingsFilterListResponses = {
    200: PaginatedPiMeetingSearchList;
};

export type ProxyvotingPimeetingsFilterListResponse = ProxyvotingPimeetingsFilterListResponses[keyof ProxyvotingPimeetingsFilterListResponses];

export type ProxyvotingRulesEngineDefinitionsListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Filter by engine name (exact match)
         */
        name?: string;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
    };
    url: '/proxyvoting/rules-engine-definitions';
};

export type ProxyvotingRulesEngineDefinitionsListResponses = {
    200: PaginatedRulesEngineDefinitionList;
};

export type ProxyvotingRulesEngineDefinitionsListResponse = ProxyvotingRulesEngineDefinitionsListResponses[keyof ProxyvotingRulesEngineDefinitionsListResponses];

export type ProxyvotingRulesEngineDefinitionsCreateData = {
    body: RulesEngineDefinitionCreateRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/rules-engine-definitions';
};

export type ProxyvotingRulesEngineDefinitionsCreateResponses = {
    201: RulesEngineDefinition;
};

export type ProxyvotingRulesEngineDefinitionsCreateResponse = ProxyvotingRulesEngineDefinitionsCreateResponses[keyof ProxyvotingRulesEngineDefinitionsCreateResponses];

export type ProxyvotingRulesEngineDefinitionsRulesListData = {
    body?: never;
    path: {
        definition_id: string;
    };
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
    };
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules';
};

export type ProxyvotingRulesEngineDefinitionsRulesListResponses = {
    200: PaginatedRulesEngineRuleList;
};

export type ProxyvotingRulesEngineDefinitionsRulesListResponse = ProxyvotingRulesEngineDefinitionsRulesListResponses[keyof ProxyvotingRulesEngineDefinitionsRulesListResponses];

export type ProxyvotingRulesEngineDefinitionsRulesCreateData = {
    body: RulesEngineRuleWriteRequest;
    path: {
        definition_id: string;
    };
    query?: never;
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules';
};

export type ProxyvotingRulesEngineDefinitionsRulesCreateResponses = {
    201: RulesEngineRule;
};

export type ProxyvotingRulesEngineDefinitionsRulesCreateResponse = ProxyvotingRulesEngineDefinitionsRulesCreateResponses[keyof ProxyvotingRulesEngineDefinitionsRulesCreateResponses];

export type ProxyvotingRulesEngineDefinitionsRulesDestroyData = {
    body?: never;
    path: {
        definition_id: string;
        id: string;
    };
    query?: never;
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}';
};

export type ProxyvotingRulesEngineDefinitionsRulesDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ProxyvotingRulesEngineDefinitionsRulesDestroyResponse = ProxyvotingRulesEngineDefinitionsRulesDestroyResponses[keyof ProxyvotingRulesEngineDefinitionsRulesDestroyResponses];

export type ProxyvotingRulesEngineDefinitionsRulesUpdateData = {
    body: RulesEngineRuleWriteRequest;
    path: {
        definition_id: string;
        id: string;
    };
    query?: never;
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}';
};

export type ProxyvotingRulesEngineDefinitionsRulesUpdateResponses = {
    200: RulesEngineRule;
};

export type ProxyvotingRulesEngineDefinitionsRulesUpdateResponse = ProxyvotingRulesEngineDefinitionsRulesUpdateResponses[keyof ProxyvotingRulesEngineDefinitionsRulesUpdateResponses];

export type ProxyvotingRulesEngineDefinitionsDestroyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/proxyvoting/rules-engine-definitions/{id}';
};

export type ProxyvotingRulesEngineDefinitionsDestroyErrors = {
    /**
     * No response body
     */
    404: unknown;
    /**
     * No response body
     */
    409: unknown;
};

export type ProxyvotingRulesEngineDefinitionsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ProxyvotingRulesEngineDefinitionsDestroyResponse = ProxyvotingRulesEngineDefinitionsDestroyResponses[keyof ProxyvotingRulesEngineDefinitionsDestroyResponses];

export type ProxyvotingRulesEngineDefinitionsRetrieveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/proxyvoting/rules-engine-definitions/{id}';
};

export type ProxyvotingRulesEngineDefinitionsRetrieveResponses = {
    200: RulesEngineDefinition;
};

export type ProxyvotingRulesEngineDefinitionsRetrieveResponse = ProxyvotingRulesEngineDefinitionsRetrieveResponses[keyof ProxyvotingRulesEngineDefinitionsRetrieveResponses];

export type ProxyvotingRulesEngineDefinitionsByNameDestroyData = {
    body?: never;
    path: {
        name: string;
    };
    query?: never;
    url: '/proxyvoting/rules-engine-definitions/by-name/{name}';
};

export type ProxyvotingRulesEngineDefinitionsByNameDestroyErrors = {
    /**
     * No response body
     */
    404: unknown;
    /**
     * No response body
     */
    409: unknown;
};

export type ProxyvotingRulesEngineDefinitionsByNameDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type ProxyvotingRulesEngineDefinitionsByNameDestroyResponse = ProxyvotingRulesEngineDefinitionsByNameDestroyResponses[keyof ProxyvotingRulesEngineDefinitionsByNameDestroyResponses];

export type ProxyvotingRulesEngineDefinitionsNamesRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/proxyvoting/rules-engine-definitions/names';
};

export type ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses = {
    200: RulesEngineNamesResponse;
};

export type ProxyvotingRulesEngineDefinitionsNamesRetrieveResponse = ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses[keyof ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses];

export type ProxyvotingSviProposalOverwriteCreateData = {
    body: SplitVoteInstructionProposalOverwriteRequest;
    path?: never;
    query?: never;
    url: '/proxyvoting/svi/proposal/overwrite';
};

export type ProxyvotingSviProposalOverwriteCreateResponses = {
    201: SplitVoteInstructionProposalOverwrite;
};

export type ProxyvotingSviProposalOverwriteCreateResponse = ProxyvotingSviProposalOverwriteCreateResponses[keyof ProxyvotingSviProposalOverwriteCreateResponses];

export type ProxyvotingSviProposalOverwriteReasonsListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
    };
    url: '/proxyvoting/svi/proposal/overwrite/reasons';
};

export type ProxyvotingSviProposalOverwriteReasonsListResponses = {
    200: PaginatedSplitVoteInstructionOverwriteReasonList;
};

export type ProxyvotingSviProposalOverwriteReasonsListResponse = ProxyvotingSviProposalOverwriteReasonsListResponses[keyof ProxyvotingSviProposalOverwriteReasonsListResponses];

export type TransparencyInstrumentsListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Filter on whether the instrument is composite.
         */
        is_composite?: boolean;
        isins?: Array<string>;
        mifir_codes?: Array<string>;
        /**
         * When true, restrict to instruments whose CFI code grants voting rights.
         */
        only_with_voting_rights?: boolean;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        public_security_id_names?: Array<string>;
        /**
         * Case-insensitive prefix match on ISIN OR substring match on title.
         */
        search?: string;
    };
    url: '/transparency/instruments/';
};

export type TransparencyInstrumentsListResponses = {
    200: PaginatedInstrumentList;
};

export type TransparencyInstrumentsListResponse = TransparencyInstrumentsListResponses[keyof TransparencyInstrumentsListResponses];

export type TransparencyInstrumentsCreateData = {
    body: InstrumentWriteRequest;
    path?: never;
    query?: never;
    url: '/transparency/instruments/';
};

export type TransparencyInstrumentsCreateResponses = {
    201: Instrument;
};

export type TransparencyInstrumentsCreateResponse = TransparencyInstrumentsCreateResponses[keyof TransparencyInstrumentsCreateResponses];

export type TransparencyInstrumentsDestroyData = {
    body?: never;
    path: {
        isin: string;
    };
    query?: never;
    url: '/transparency/instruments/{isin}/';
};

export type TransparencyInstrumentsDestroyResponses = {
    /**
     * No response body
     */
    204: void;
};

export type TransparencyInstrumentsDestroyResponse = TransparencyInstrumentsDestroyResponses[keyof TransparencyInstrumentsDestroyResponses];

export type TransparencyInstrumentsRetrieveData = {
    body?: never;
    path: {
        isin: string;
    };
    query?: never;
    url: '/transparency/instruments/{isin}/';
};

export type TransparencyInstrumentsRetrieveResponses = {
    200: Instrument;
};

export type TransparencyInstrumentsRetrieveResponse = TransparencyInstrumentsRetrieveResponses[keyof TransparencyInstrumentsRetrieveResponses];

export type TransparencyInstrumentsUpdateData = {
    body: InstrumentWriteRequest;
    path: {
        isin: string;
    };
    query?: never;
    url: '/transparency/instruments/{isin}/';
};

export type TransparencyInstrumentsUpdateResponses = {
    200: Instrument;
};

export type TransparencyInstrumentsUpdateResponse = TransparencyInstrumentsUpdateResponses[keyof TransparencyInstrumentsUpdateResponses];

export type TransparencyInstrumentsFetchMinimalCreateData = {
    body: FetchMinimalInstrumentsRequestRequest;
    path?: never;
    query?: never;
    url: '/transparency/instruments/fetch-minimal/';
};

export type TransparencyInstrumentsFetchMinimalCreateResponses = {
    200: FetchMinimalInstrumentsResponse;
};

export type TransparencyInstrumentsFetchMinimalCreateResponse = TransparencyInstrumentsFetchMinimalCreateResponses[keyof TransparencyInstrumentsFetchMinimalCreateResponses];

export type TransparencyInstrumentsUnassociatedRetrieveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/transparency/instruments/unassociated/';
};

export type TransparencyInstrumentsUnassociatedRetrieveResponses = {
    200: UnassociatedInstrumentsResponse;
};

export type TransparencyInstrumentsUnassociatedRetrieveResponse = TransparencyInstrumentsUnassociatedRetrieveResponses[keyof TransparencyInstrumentsUnassociatedRetrieveResponses];

export type TransparencyPublicSecurityIdsListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Filter by associated instrument ISINs.
         */
        instrument_isins?: Array<string>;
        /**
         * Filter by full public security ID names (format 'securityIDTypes/{type}/securityIDs/{value}').
         */
        names?: Array<string>;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Filter by public security ID type names (format 'securityIDTypes/{type}').
         */
        public_security_id_type_names?: Array<string>;
        /**
         * Filter by public security ID values.
         */
        values?: Array<string>;
    };
    url: '/transparency/public-security-ids/';
};

export type TransparencyPublicSecurityIdsListResponses = {
    200: PaginatedPublicSecurityIdList;
};

export type TransparencyPublicSecurityIdsListResponse = TransparencyPublicSecurityIdsListResponses[keyof TransparencyPublicSecurityIdsListResponses];

export type VotingOperationsPiballotsFilterListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Filter ballots by workflow checker email - exact string match.
         */
        checker?: string;
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Custodian account identifier - exact string match.
         */
        custodian_account_number?: string;
        /**
         * External ballot identifier - exact string match.
         */
        external_id?: string;
        /**
         * Filter ballots by fund manager title - case-insensitive substring match.
         */
        fund_manager_title?: string;
        /**
         * Filter ballots by fund title - case-insensitive substring match.
         */
        fund_title?: string;
        /**
         * Filter ballots by whether they have a workflow checker email assigned. True for ballots with checker, False for ballots without checker, omit for all.
         */
        has_checker?: boolean;
        /**
         * Filter ballots by whether they have a workflow submitter email assigned. True for ballots with submitter, False for ballots without submitter, omit for all.
         */
        has_submitter?: boolean;
        /**
         * Filter ballots by scope. True for in-scope (any policy support field is true), False for out-of-scope (all policy support fields are false), omit for all.
         */
        in_scope?: boolean;
        /**
         * ISIN (International Securities Identification Number) - exact match filter. Must be 12-character alphanumeric code.
         */
        isin?: string;
        /**
         * Filter ballots by whether they are linked to a general meeting. True for linked, False for unlinked, omit for all.
         */
        linked?: boolean;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * Filter ballots by organization title - case-insensitive substring match.
         */
        organization_title?: string;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Filter ballots by whether the 'proxy_intermediary_id' and 'proxy_intermediary_meeting_id' match the provided meeting name.
         * Expected format:'proxyIntermediaries/{proxy_intermediary_id}/meetings/{proxy_intermediary_meeting_id}'
         */
        pi_meeting_name?: string;
        /**
         * Proxy intermediary(s) managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
         *
         * * `Proxymity` - Proxymity
         * * `ProxyEdge` - ProxyEdge
         * * `ProxyExchange` - ProxyExchange
         */
        proxy_intermediaries?: Array<'ProxyEdge' | 'ProxyExchange' | 'Proxymity'>;
        /**
         * Filter ballots by proxy intermediary title - exact string match.
         */
        proxy_intermediary?: string;
        /**
         * General search across organization title, ballot external ID, and ISIN - case-insensitive substring match.
         */
        search?: string;
        /**
         * Filter ballots by whether split vote checking is required. True for required, False for not required, omit for all.
         */
        split_vote_check_required?: boolean;
        /**
         * Filter ballots by workflow status. Multiple values can be selected to match any of the specified statuses.
         *
         * * `invalid` - Invalid
         * * `not_submitted_in_testing` - Not Submitted in Testing
         * * `not_submitted_unvoted` - Not Submitted Unvoted
         * * `not_submitted_no_entitlements` - Not Submitted No Entitlements
         * * `not_submitted_undefined` - Not Submitted Undefined
         * * `needs_attention` - Needs Attention
         * * `ineligible` - Ineligible
         * * `cancelled` - Cancelled
         * * `meeting_needs_refining` - Meeting Needs Refining
         * * `meeting_voting_enabled` - Meeting Voting Enabled
         * * `entitled_to_vote` - Entitled to Vote
         * * `ready_for_split_vote` - Ready for Split Vote
         * * `late_vote_process` - Late Vote Process
         * * `split_vote_awaiting_check` - Split Vote Awaiting Check
         * * `split_vote_submitted` - Split Vote Submitted
         * * `successful` - Successful
         * * `rejected` - Rejected
         * * `overridden` - Overridden
         * * `in_testing` - In Testing
         */
        status?: Array<'cancelled' | 'entitled_to_vote' | 'in_testing' | 'ineligible' | 'invalid' | 'late_vote_process' | 'meeting_needs_refining' | 'meeting_voting_enabled' | 'needs_attention' | 'not_submitted_in_testing' | 'not_submitted_no_entitlements' | 'not_submitted_undefined' | 'not_submitted_unvoted' | 'overridden' | 'ready_for_split_vote' | 'rejected' | 'split_vote_awaiting_check' | 'split_vote_submitted' | 'successful'>;
        /**
         * Filter ballots by workflow submitter email - exact string match.
         */
        submitter?: string;
        /**
         * Filter ballots with vote deadline after or equal to this UTC datetime.
         */
        vote_deadline_after?: Date;
        /**
         * Filter ballots with vote deadline before or equal to this UTC datetime.
         */
        vote_deadline_before?: Date;
    };
    url: '/voting-operations/piballots/filter';
};

export type VotingOperationsPiballotsFilterListResponses = {
    200: PaginatedPiBallotSearchList;
};

export type VotingOperationsPiballotsFilterListResponse = VotingOperationsPiballotsFilterListResponses[keyof VotingOperationsPiballotsFilterListResponses];

export type VotingOperationsPimeetingsFilterListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Filter meetings by assigned checker user email address - exact match.
         */
        assigned_checker_user_id?: string;
        /**
         * Filter meetings by assigned refiner user email address - exact match.
         */
        assigned_refiner_user_id?: string;
        /**
         * The pagination cursor value.
         */
        cursor?: string;
        /**
         * Filter meetings with earliest ballot submission deadline is after or equal to this UTC datetime,
         */
        earliest_ballot_submission_deadline_after?: Date;
        /**
         * Filter meetings with earliest ballot submission before or equal to this UTC datetime.
         */
        earliest_ballot_submission_deadline_before?: Date;
        /**
         * Filter meetings by ballot presence. True for meetings with ballots, False for meetings without ballots, omit for all.
         */
        has_ballots?: boolean;
        /**
         * Filter meetings by checker presence. True for meetings with checker, False for meetings without checker, omit for all.
         */
        has_checker?: boolean;
        /**
         * Filter meetings by refiner presence. True for meetings with refiner, False for meetings without refiner, omit for all.
         */
        has_refiner?: boolean;
        /**
         * Filter meetings by scope. True for in-scope (any policy support field is true), False for out-of-scope (all policy support fields are false), omit for all.
         */
        in_scope?: boolean;
        /**
         * Filter meetings by whether they are linked to Tumelo meetings. True for linked, False for unlinked, omit for all.
         */
        linked_to_tumelo_meeting?: boolean;
        /**
         * Filter meetings created after or equal to this UTC datetime.
         */
        meeting_create_time_after?: Date;
        /**
         * Filter meetings created before or equal to this UTC datetime.
         */
        meeting_create_time_before?: Date;
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string;
        /**
         * Number of results to return per page.
         */
        page_size?: number;
        /**
         * Proxy intermediary(s) managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
         *
         * * `Proxymity` - Proxymity
         * * `ProxyEdge` - ProxyEdge
         * * `ProxyExchange` - ProxyExchange
         */
        proxy_intermediaries?: Array<'ProxyEdge' | 'ProxyExchange' | 'Proxymity'>;
        /**
         * Proxy intermediary managing the meetings. Options: Proxymity, ProxyEdge, ProxyExchange, or omit for all.
         *
         * * `Proxymity` - Proxymity
         * * `ProxyEdge` - ProxyEdge
         * * `ProxyExchange` - ProxyExchange
         */
        proxy_intermediary?: 'ProxyEdge' | 'ProxyExchange' | 'Proxymity';
        /**
         * General search across meeting external ID, organization title, and security IDs - case-insensitive substring match. Maximum 255 characters.
         */
        search?: string;
        /**
         * Filter meetings by workflow status. Multiple values can be selected to match any of the specified statuses.
         *
         * * `invalid` - Invalid
         * * `new` - New
         * * `unlinked` - Unlinked
         * * `unsupported` - Unsupported
         * * `needs_attention` - Needs Attention
         * * `cancelled` - Cancelled
         * * `cancellation_incomplete` - Cancellation Incomplete
         * * `ready_for_refinement` - Ready for Refinement
         * * `refinement_complete` - Refinement Complete
         * * `manual_voting_enabled` - Manual Voting Enabled
         * * `entitled_to_vote` - Entitled to Vote
         * * `ready_for_split_vote` - Ready for Split Vote
         * * `split_vote_submitted` - Split Vote Submitted
         * * `successful` - Successful
         * * `rejected` - Rejected
         * * `overridden` - Overridden
         * * `partial_success` - Partial Success
         */
        status?: Array<'cancellation_incomplete' | 'cancelled' | 'entitled_to_vote' | 'invalid' | 'manual_voting_enabled' | 'needs_attention' | 'new' | 'overridden' | 'partial_success' | 'ready_for_refinement' | 'ready_for_split_vote' | 'refinement_complete' | 'rejected' | 'split_vote_submitted' | 'successful' | 'unlinked' | 'unsupported'>;
        /**
         * Filter meetings with submission deadline after or equal to this UTC datetime, where the latest valid_to SII date is before this datetime, with an 8 month buffer.
         */
        submission_deadline_after?: Date;
        /**
         * Filter meetings with submission deadline before or equal to this UTC datetime.
         */
        submission_deadline_before?: Date;
    };
    url: '/voting-operations/pimeetings/filter';
};

export type VotingOperationsPimeetingsFilterListResponses = {
    200: PaginatedPiMeetingSearchList;
};

export type VotingOperationsPimeetingsFilterListResponse = VotingOperationsPimeetingsFilterListResponses[keyof VotingOperationsPimeetingsFilterListResponses];
